/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'MEUS VÍDEOS CURTOS',
    see_more: 'VER MAIS',
    no_shorts_found: 'Nenhum short encontrado',
    shorts: 'Shorts',
    general_information: 'Informações gerais',
    gamification: 'Gamificação',
    click_to_select_files: 'Clique para selecionar arquivos',
    selected_files: 'Arquivos selecionados',
    uploaded: 'Enviado',
    failed: 'Falhou',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'O sistema analisará automaticamente e selecionará os documentos mais relevantes da biblioteca da sua organização com base nos requisitos de conteúdo.',
    select_from_library: ' Selecionar da biblioteca',
    search_document: 'Pesquisar documento...',
    selected: 'Selecionado',
    loading_documents: 'Carregando documentos...',
    review_generated_content: 'Revisar conteúdo gerado',
    confirm_and_replace_content: 'Confirmar e substituir conteúdo',
    the_generate_content_will_replace:
      'O conteúdo gerado substituirá o texto existente nas páginas selecionadas. Se não quiser aplicar essas alterações, você pode voltar à etapa anterior.',
    pages_to_be_updated: 'Páginas a serem atualizadas',
    generated_revisions: 'Revisões geradas',
    lesson_preview: 'Pré-visualização da lição',
    create_new_folder: 'Criar nova pasta',
    rename_item: 'Renomear item',
    enter_folder_name: 'Digite o nome da pasta:',
    enter_new_name: 'Digite o novo nome:',
    folder_name: 'Nome da pasta:',
    new_name: 'Novo nome',
    move_items: 'Mover itens',
    copy_items: 'Copiar itens',
    move_here: 'Mover para cá',
    copy_here: 'Copiar para cá',
    select_destination_library_and_folder:
      'Selecione a biblioteca de destino e a pasta:',
    items_selected: 'Itens selecionados',
    version: 'Versão',
    modified_by: 'Modificado por',
    size: 'Tamanho',
    restore: 'Restaurar',
    are_you_sure_you_want_to_restore_this_version:
      'Tem certeza de que deseja restaurar esta versão?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Isso substituirá a versão atual pela selecionada.',
    restore_this_version: 'Restaurar esta versão',
    restore_not_available: 'Restauração não disponível',
    version_history: 'Histórico de versões:',
    by_making_items_public:
      'Ao tornar itens públicos, eles ficarão visíveis para todos. Revise os termos e condições antes de continuar.',
    the_selected_items_will_be_copied:
      'Os itens selecionados serão copiados para sua biblioteca pública e visíveis para todos.',
    the_selected_items_will_be_copied_to_org:
      'Os itens selecionados serão copiados para a biblioteca da organização e visíveis para todos os membros da organização.',
    the_selected_items_will_be_copied_to_your_private:
      'Os itens selecionados serão copiados para sua biblioteca privada e visíveis apenas para você.',
    loading_organization: 'Carregando usuários da organização...',
    click_download_to_view: 'Clique em "Baixar" para visualizar',
    archive_file: 'Arquivo de arquivo',
    no_preview_available: 'Pré-visualização não disponível',
    audit_report: 'Relatório de auditoria',
    audit_type: 'Tipo de ação',
    i_agree_to_the_terms_and_conditions:
      'Eu concordo com os termos e condições.',
    this_file_is_indexed_for_ai: 'Este arquivo está indexado para IA.',
    file_is_not_indexed_for_ai: 'Arquivo não está indexado para IA.',
    no_users_found: 'Nenhum usuário encontrado',
    no_users_available: 'Nenhum usuário disponível',
    add_people: 'Adicionar pessoas',
    people: 'Pessoas',
    access_type: 'Tipo de acesso',
    no_group_found: 'Nenhum grupo encontrado',
    add_group: 'Adicionar grupo',
    groups: 'Grupos',
    users_top: 'Usuário(s)',
    confirm_delete: 'Confirmar exclusão',
    do_you_want_remove: 'Tem certeza de que deseja remover',
    form_this_documents_permissions: 'das permissões deste documento?',
    no_users_found_in_this_group: 'Nenhum usuário encontrado neste grupo',
    add_selected_users: 'Adicionar usuários selecionados',
    choose_users_from_the_list: 'Escolha usuários da lista',
    selected_users: 'Usuários selecionados',
    archived: 'Arquivado',
    request_approval: 'Solicitar aprovação',
    document_in_review: 'Documento em revisão',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    comment: 'Comentário:',
    enter_your_commit: 'Digite seu comentário...',
    confirm_cancel: 'Confirmar cancelamento',
    upload_3d_zip: 'Enviar ZIP 3D',
    delete_items: 'Excluir itens',
    video_upload_request: 'Solicitação de envio de vídeo',
    reject_video: 'Rejeitar vídeo',
    enter_rejection_reason: 'Digite o motivo da rejeição...',
    please_provide_a_reason_for_reejection_this_video:
      'Por favor, forneça um motivo para rejeitar este vídeo:',
    generate_trivia_with_ai: 'Gerar trivia com IA',
    select_category: 'Selecionar categoria:',
    number_of_question: 'Número de perguntas',
    generated_questions: 'Perguntas geradas',
    this_will_clear_all_generate_question:
      'Isso limpará todas as perguntas geradas. Continuar?',
    sure_delete: 'Tem certeza de que deseja excluir?',
    delete_this_question: 'Tem certeza de que deseja excluir esta pergunta?',
    loading_quiz: 'Carregando quiz...',
    creteing_file: 'Criando arquivo',
    opening_desktop_app: 'Abrindo aplicativo de desktop',
    this_folder_is_empty: 'Esta pasta está vazia',
    select_a_competition: 'Selecione uma competição...',
    activity_badges: 'Insígnias de atividade',
    awarded_every_badges:
      'Concedido a cada 4, 8, 16, 32, 64, 128, 256, 512 logins',
    learning_badges: 'Insígnias de aprendizado',
    awarded_every_courses:
      'Concedido a cada 1, 4, 8, 16, 32, 64, 128 cursos concluídos',
    test_badges: 'Insígnias de teste',
    awarded_every_passes_tests:
      'Concedido a cada 2, 4, 8, 16, 32, 64, 128, 256 testes aprovados',
    assignment_badges: 'Insígnias de tarefas',
    awarded_every_passed_assignments:
      'Concedido a cada 1, 2, 4, 8, 16, 32, 64, 128 tarefas aprovadas',
    perfectionism_badges: 'Insígnias de perfeccionismo',
    awarded_every_assignments_with_scrore:
      'Concedido a cada 1, 2, 4, 8, 16, 32, 64, 128 testes ou tarefas com pontuação de 90%+',
    communication_badges: 'Insígnias de comunicação',
    awarded_every_topics_or_comments:
      'Concedido a cada 2, 4, 8, 16, 32, 64, 128, 256 tópicos ou comentários',
    certification_badges: 'Insígnias de certificação',
    awarded_every_certificates:
      'Concedido a cada 1, 2, 4, 8, 16, 32, 64, 128 certificados',
    level_name: 'Nome do nível',
    delete_competition: 'Excluir competição',
    this_week: 'Esta semana',
    this_year: 'Este ano',
    make_organization: 'Tornar organização',
    no_results_found: 'Nenhum resultado encontrado para',
    no_items_available: 'Nenhum item disponível',
    help_video: 'Vídeos de ajuda',
    select_a_video_from_the_list:
      'Selecione um vídeo da lista para começar a aprender'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Arraste os arquivos e selecione onde fazer upload.',
    duplicate_lessoon: 'Aula já presente no curso',
    skill_rule_title: 'Por favor, insira o título da Jornada de Habilidades',
    imageCreatorTitle: 'Criador de Imagens',
    isTranslated: 'Traduzido',
    translationCourseDesc:
      'A tradução deste curso pode levar alguns minutos. Obrigado pela paciência!',
    translateCourseTip:
      'Crie um curso traduzido que pode ser modificado de forma independente do original, incluindo todas as aulas e páginas.',
    translateModalBtn: 'Traduzir',
    translationSuccess: 'O curso "<0/>" foi traduzido com sucesso!',
    translatingCourse: 'Traduzindo o curso...',
    translateModalTitle: 'Traduzir Curso',
    translateSelectLang: 'Selecionar Idioma',
    fileDeleteconfirm:
      'Tem certeza de que deseja excluir este arquivo? Isso não pode ser desfeito.',
    fileDeleteMessage: 'Arquivo excluído com sucesso.',
    fileDeleteFailedMessage: 'Falha ao excluir o arquivo!',
    fileDelete: 'Excluir este arquivo.',
    certificate_save_btn: 'Adicionar Certificado a ',
    maze_path_info: 'Não há caminhos disponíveis para o grafo!',
    file_size_mb: 'O tamanho do arquivo deve ser menor que 25 MB!',
    reports: {
      products: 'Produtos',
      users: 'Usuários',
      ph_username: 'Buscar usuário por nome de usuário',
      ph_id: 'Buscar usuário por número de ID',
      ph_email: 'Buscar usuário por e‑mail'
    },
    select_upload_section_id: 'Arquivo de seção é obrigatório',
    tags_all: 'Todos',
    delete_file_confirm: 'Tem certeza de que deseja excluir este arquivo?',
    delete_file_title: 'Excluir Arquivo',
    tooltip_publish: 'Publicar o curso na opção selecionada',
    tooltip_save: 'Salvar o curso com as atualizações atuais',
    tooltip_next: 'Ir para a próxima configuração do curso',
    tooltip_finish: 'Concluir e salvar as atualizações atuais',
    stories_modal: {
      title_upload: 'Carregar Histórias',
      title_update: 'Atualizar Histórias',
      title_audio: 'Arquivo de História em Áudio',
      btn_upload: 'Carregar',
      btn_update: 'Atualizar',
      btn_close: 'Fechar',
      btn_cancel: 'Cancelar',
      lbl_cover: 'Imagem de Capa da História',
      rule_cover: 'Por favor, carregue a capa da história em áudio!',
      lbl_title: 'Título da História em Áudio',
      rule_title: 'Por favor, insira o título da história em áudio!',
      lbl_description: 'Descrição da História em Áudio',
      rule_description: 'Por favor, insira a descrição da história em áudio!',
      lbl_file: 'Carregar arquivo de história em áudio',
      rule_file: 'Por favor, carregue o arquivo de história em áudio!',
      rule_file_type:
        'Por favor, carregue um arquivo de história em áudio válido!',
      lbl_select_file: 'Selecionar arquivo de história em áudio',
      msg_valid_file:
        'Por favor, selecione um arquivo de história em áudio válido!',
      msg_success: 'Arquivo de história em áudio carregado com sucesso',
      msg_failed: 'Falha ao atribuir dados de mídia!',
      msg_error: 'Erro ao carregar o arquivo!'
    },
    audio_modal: {
      title_upload: 'Carregar',
      title_update: 'Atualizar',
      title_audio: 'Arquivo de Áudio',
      btn_upload: 'Carregar',
      btn_update: 'Atualizar',
      btn_close: 'Fechar',
      btn_cancel: 'Cancelar',
      lbl_cover: 'Capa de Áudio',
      rule_cover: 'Por favor, carregue a capa de áudio!',
      lbl_title: 'Título do Áudio',
      rule_title: 'Por favor, insira o título do áudio!',
      lbl_description: 'Descrição do Áudio',
      rule_description: 'Por favor, insira a descrição do áudio!',
      lbl_file: 'Carregar arquivo de áudio',
      rule_file: 'Por favor, carregue um arquivo de áudio!',
      rule_file_type: 'Por favor, carregue um arquivo de áudio válido!',
      lbl_select_file: 'Selecionar arquivo de áudio',
      msg_valid_file: 'Por favor, selecione um arquivo de áudio válido!',
      msg_success: 'Arquivo de áudio carregado com sucesso',
      msg_failed: 'Falha ao atribuir dados de mídia!',
      msg_error: 'Erro ao carregar o arquivo!'
    },
    info_episode: 'Uma imagem de capa para o episódio.',
    btn_delete_episode: 'Excluir este episódio do podcast.',
    btn_edit_marketplace: 'Editar detalhes do Marketplace.',
    btn_save_marketplace: 'Salvar as alterações atuais.',
    btn_ai_podcast: 'Criar episódio de podcast com IA.',
    btn_upload_podcast: 'Carregar seu próprio áudio de podcast.',
    attach_file:
      'Carregue arquivos para compartilhar mais conteúdo com seu público',
    fileDownload: 'Baixar este arquivo.',
    singleEpishode: 'Episódio',
    podcast_music: 'podcast, música & histórias',
    publishHeader: 'Publicar Podcasts, Música & Histórias',
    editHeader: 'Editar Podcasts, Música & Histórias',
    createHeader: 'Criar Podcasts, Música & Histórias',
    marketplaceHeader:
      'Detalhes do Marketplace de Podcasts, Música & Histórias',
    message_marketplace: 'Por favor, complete o formulário do Marketplace!',
    create_podcast_live: 'Podcast e Música Ao Vivo',
    create_podcast_custom: 'Podcast e Música Personalizados',
    create_podcast_stories: 'Histórias',
    ai_Assisted_podcast_reation: 'Podcast e Música com IA',
    publishTitle:
      'Publique podcasts, músicas e histórias para visualização pública.',
    customButton: 'Criar Personalizado',
    customTitle: 'Salve as alterações feitas no podcast.',
    updateButton: 'Atualizar',
    createButton: 'Criar',
    createNewButton: 'Criar Novo',
    updateTitle: 'Atualize os detalhes do podcast, música e histórias atuais.',
    createTitle: 'Criar novo podcast, música e histórias',
    createNewTitle:
      'Novo podcast, música & histórias serão criados com base nos dados atuais.',
    podcastTitle: 'Lista de Episódios',
    podcastStoryTitle: 'Lista de Episódios de Histórias',
    podcastToolTipTitle: 'Lista de episódios de podcast',
    uploadAudio: 'Carregar Áudio',
    aiAudio: 'Áudio com IA',
    emptyPodcast: 'Ainda não há gravações de podcast, música ou histórias.',
    emptyStoriesPodcast: 'Nenhuma história adicionada ainda.',
    emptyCreatePodcast:
      'Por favor, crie um podcast para poder adicionar áudio.',
    playPodcast: 'Reproduzir o podcast, música e histórias selecionados.',
    pausePodcast: 'Pausar o podcast, música e histórias selecionados.',
    selectPodcast: 'Selecionar este podcast, música & histórias.',
    downloadPodcast: 'Baixar este áudio.',
    uploadAudioFile: 'Carregue um novo áudio e substitua o atual.',
    deleteConfirm: 'Você tem certeza que deseja excluir este áudio?',
    roomName: 'Nome do Podcast',
    addGuestTitle: 'ADICIONAR CONVIDADO',
    showTime: 'Horário do Show',
    startTime: 'Hora de Início',
    endTime: 'Hora de Término',
    erorMsgImg: 'Por favor, selecione uma imagem válida.',
    failedMsgImg: 'Falha ao carregar a imagem. Por favor, tente novamente!',
    failedMsgUpload: 'Falha ao carregar a capa!',
    btnCoverUpload: 'Carregar Capa',
    is_private: 'Privado',
    to_attach: 'Anexar Arquivo',
    file_attached: 'Arquivo Anexado',
    main_event: 'Evento Principal',
    event: 'Evento',
    upload_pdf: 'Carregar PDF',
    portrait: 'Retrato',
    landscape: 'Paisagem',
    import_from_library: 'Importar Texto da Biblioteca de Mídia',
    question_answer_ai: 'Perguntas/Respostas com IA',
    take_maze: 'ENTRAR no MetaMaze',
    training: 'Treinamento',
    select_transcribe_locale: 'Selecione o idioma para transcrição',
    transcribe_limit: 'Insira os minutos para transcrição',
    not_complete: 'Informações do Marketplace incompletas',
    complete: 'Informações do Marketplace completas',
    not_admin:
      'É necessário privilégio de administrador para publicar no Marketplace',
    no_course:
      'Insira um título e selecione uma imagem para ativar o Marketplace',
    scorm_not_complete:
      'Insira um título e selecione uma imagem para enviar o arquivo SCORM',
    not_found_maze: 'MetaMaze não encontrado',
    email_require: 'E-mails são obrigatórios',
    poll_required: 'Dados da enquete são obrigatórios',
    alert: 'Alerta!',
    warning: 'Aviso!',
    ok: 'Ok',
    cancel: 'Cancelar',
    done: 'Concluído',
    insert: 'Inserir',
    private: 'Privado',
    public: 'Público',
    no_connection: 'Conexão com a Internet perdida',
    switch: 'Alternar',
    share_screen: 'Compartilhar tela',
    stop_share_screen: 'Parar de compartilhar tela',
    share_screen_with_camera: 'Compartilhar tela com câmera',
    stop_share_screen_with_camera: 'Parar de compartilhar tela com câmera',
    camera_on: 'Câmera ligada',
    camera_off: 'Câmera desligada',
    mic_on: 'Ativar microfone',
    mic_off: 'Desativar microfone',
    fullscreen: 'Tela cheia',
    live_now: 'Ao Vivo',
    schedule_on: 'Agendado para',
    organisations: 'Organizações',
    org_groups: 'Grupos da organização',
    specific_user: 'Usuário específico',
    gif: 'GIF',
    unavailable: 'Indisponível',
    yes: 'Sim',
    no: 'Não',
    event_duration_message: 'Máximo de 300 minutos (5 horas)',
    send_email: 'Enviar notificação por e-mail',
    admin_only: 'Apenas administrador',
    join: 'Participar',
    leave: 'Sair',
    share: 'Compartilhar',
    share_text: 'Digite o e-mail de quem você quer compartilhar este arquivo.',
    share_text_title: 'Compartilhar PDF',
    share_text_title_txt: 'Compartilhar texto',
    select_users: 'Selecionar usuários',
    delete: 'Excluir',
    attachment_event: 'Anexos do evento:',
    transcribe_limit: 'Minutos de Transcrição',
    monthly_transcribe: 'Limite mensal de transcrição:',
    enable_ai: 'Ativar IA:',
    enable_maze: 'Ativar MetaMaze:',
    media_service: 'Serviço de mídia',
    allow_others: 'Permitir edição por outros',
    join_breakout_room: 'Entrar na sala paralela',
    bio: 'Biografia',
    linkedin: 'LinkedIn',
    select_org_report:
      'Encontre e selecione uma organização para gerar o relatório.',
    org_image_not_found: 'Imagem não encontrada',
    insert_text: 'Inserir texto',
    insert_question_answer: 'Perguntas/Respostas com IA',
    modal_title2: 'Galeria de Textos',
    my_text_library: 'Minha Biblioteca de Textos',
    ai: 'IA',
    public_text_library: 'Biblioteca Pública de Textos',
    organization_text_library: 'Biblioteca da Organização',
    no_transcribed_text: 'Nenhum texto transcrito encontrado',
    public_text_not_found: 'Texto transcrito público não encontrado',
    org_text_not_found: 'Texto transcrito da organização não encontrado',
    org_video_not_found: 'Vídeo não encontrado',
    canva: 'Fazer pelo Canva',
    canva_open: 'Clique aqui para abrir o editor do Canva.',
    pdf: 'PDF',
    txt: 'TEXTO',
    human: 'Premium',
    shared_file: 'Seu arquivo foi compartilhado com sucesso.',
    error_shared_file:
      'Houve um problema ao compartilhar o arquivo. Tente novamente.',
    publish: 'Publicar',
    maze_scenes: 'Cenas do MetaMaze',
    pexel_images: 'Imagens do Pexel',
    group: 'Grupo',
    group_name: 'Nome do Grupo',
    select_group: 'Selecionar Grupo',
    search_maze: 'Pesquisar MetaMaze',
    hosts: 'Anfitriões',
    avg_score: 'Pontuação Percentual',
    maze_report: 'Relatório do Maze',
    maze_view: 'Visualização do Maze',
    title_maze: 'MetaMaze',
    author: 'Autor',
    match: 'Caminho Correspondente',
    preview_mazeTitle: 'Título: ',
    other: 'Outro',
    total: 'TOTAL',
    report_course: 'CURSO',
    report_courses: 'CURSOS',
    report_event: 'EVENTO',
    report_events: 'EVENTOS',
    report_maze: 'MAZE',
    report_personalize_learning: 'APRENDIZAGEM PERSONALIZADA',
    report_live_assessment: 'AVALIAÇÃO AO VIVO',
    report_live_assessments: 'AVALIAÇÕES AO VIVO',
    report_skill_journey: 'JORNADA DE HABILIDADES',
    skill_journey: 'Jornada de Habilidades',
    skill_journeys: 'Jornadas de Habilidades',
    date: 'DATA: ',
    search_people: 'Procurar Pessoas',
    passed: 'APROVADO',
    failed: 'REPROVADO',
    item: 'ITEM',
    type: 'TIPO',
    minimum_pass_score: 'PONTUAÇÃO MÍNIMA PARA APROVAÇÃO',
    resources_count: 'QUANTIDADE DE RECURSOS',
    back: 'VOLTAR',
    resources: 'RECURSOS',
    time_spent: 'TEMPO GASTO (MINUTOS)',
    detail: 'DETALHES',
    watched_time_mins: 'TEMPO ASSISTIDO (MINUTOS)',
    personalize_learning: 'Aprendizagem Personalizada',
    result: 'Resultado',
    assessment_title: 'Título',
    marketPlace_graph: 'Gráfico do Marketplace',
    attachments: 'Anexos Adicionais',
    new_scorm_course: 'Carregar um Novo Curso SCORM',
    upload_scorm_course: 'Carregar Curso SCORM',
    new_maze: 'Criar um Novo MetaMaze',
    new_skill_journey: 'Criar um Percurso de Competências',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Percurso de Competências',
    new_discussion_room: 'Criar um Novo Podcast',
    title: 'O que deseja fazer hoje?',
    build_course: 'Criar o Meu Curso',
    live_broadcast: 'Transmissão em Direto',
    invite_users: 'Convidar Utilizadores para a Minha Organização',
    build_voice_over: 'Criar a Minha Narração',
    view_reports: 'Ver Relatórios',
    upload_media: 'Carregar os Meus Conteúdos ou Trabalhos e Partilhá-los',
    main_menu: 'Menu Principal',
    get_started: 'COMEÇAR',
    search_group: 'Procurar Grupo da Organização',
    ai_course: 'Curso de IA',
    search_user: 'Procurar Nome da Empresa',
    no_maze: 'De momento, não existem MetaMaze.',
    conference_event_title: 'Eventos de Conferência',
    conference_event_subTitle: 'Eventos de Conferência Concluídos',
    conference_event: 'De momento, não existem eventos de conferência.',
    no_skill: 'De momento, não existem percursos de competências.',
    no_podcast: 'De momento, não existem podcasts.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Avaliações em Direto Anteriores',
    no_live_assessment: 'De momento, não existem avaliações em direto.',
    enrolled_courses: 'Cursos',
    my_video_channel: 'Os Meus Canais de Vídeo',
    enrolled_liveEvents: 'Eventos em Direto',
    sharebot: 'Sharebot',
    selected_language: 'Idioma selecionado',
    shareSphere_game: 'Jogo ShareSphere',
    maze: 'MetaMaze',
    skill: 'Percurso de Competências',
    channel: 'Canal',
    order: 'Ordem',
    is_record: 'Gravar',
    no_maze_found: 'Nenhum MetaMaze encontrado.',
    maze_self_limit_reached: 'Limite de autoavaliação do MetaMaze atingido.',
    metamaze_two_times: 'Já realizou este MetaMaze 2 vezes.',
    metamaze_two_times_no_result:
      'Já realizou este MetaMaze 2 vezes. Os resultados não serão registados após a segunda tentativa.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Pontuação Mínima para Passar',
    organization: 'Por favor selecione uma organização',
    pass_score_mark: 'Por favor insira uma pontuação entre 1 e 100',
    maze_cloning_success: 'O MetaMaze "<0/>" foi clonado com sucesso!',
    create_certificate: 'Criar um Certificado',
    create_badge: 'Criar um Emblema',
    certificate_added: 'Certificado Adicionado.',
    badge_added: 'Emblema Adicionado.',
    certificate_warning:
      'Não poderá editar o certificado/emblema depois de o publicar!',
    created_course_plan:
      'Edite e publique o seu curso criado e planeie eventos em direto',
    market_place_space: 'Mercado',
    select_course_language: 'Selecionar idioma (Opcional)',
    select_language: 'Selecionar idioma',
    file_upload: 'Carregamento de ficheiro',
    text: 'Escreva o texto aqui…',
    attempts_count: 'Número de Tentativas Permitidas por Utilizador',
    no_of_people_placeholder: 'Número de Pessoas',
    back_to_maze: 'Voltar ao Cenário do MetaMaze',
    edit_maze: 'Editar Maze',
    wait: 'Aguarde...',
    retry: 'Tentar novamente',
    publish_scorm_course: 'Publicar o Seu Curso SCORM',
    publish_maze: 'Publicar o Seu MetaMaze',
    import: 'Importar Elementos',
    answer_correct: 'Escolha a resposta correta',
    author_name: `Por favor, insira o nome do autor`,
    select_category: 'Por favor, selecione uma categoria',
    course_outline: 'Por favor, insira o plano do curso',
    course_obj: 'Por favor, insira os objetivos do curso',
    course_description: 'Por favor, insira a descrição do curso',
    maze_outline: 'Por favor, insira o plano do labirinto',
    maze_obj: 'Por favor, insira os objetivos do labirinto',
    maze_description: 'Por favor, insira a descrição do labirinto',
    lessons: 'Por favor, insira o número de lições',
    user_email_require: `O e-mail do utilizador é obrigatório`,
    team_size: `O tamanho da equipa é obrigatório`,
    enter_price: 'Por favor, insira um preço (5 ou mais)',
    input_title_maze: 'Por favor, insira o título do labirinto',
    trainer_bio: 'Por favor, insira a biografia do formador',
    trainer_linkedin: 'Por favor, insira o LinkedIn do formador',
    error_video: 'Por favor, insira o número de vídeos',
    input_video_link: 'Por favor, insira o link do vídeo',
    number_of_video: 'número de vídeos',
    number_of_lessions: 'número de lições',
    no_of_people_in_conference: 'Quantas pessoas estão na conferência?',
    transcribe_settings: 'Configurações de transcrição',
    transcribe: 'Transcrever',
    cloning_maze: 'A clonar MetaMaze...',
    id_number: 'Número de identificação',
    timezone: 'Fuso horário',
    edit_maze: 'Editar',
    delete_maze: 'Eliminar',
    view_maze: 'Ver',
    create_metamaze: 'Criar um MetaMaze',
    metamaze_scenario: 'Cenário do MetaMaze',
    publish_metamaze: 'Configuração de publicação',
    search_result: 'Resultados da pesquisa:',
    search_for: 'Pesquisar por',
    search_no_result: '- Sem resultados disponíveis!',
    channel_no_available: 'Nenhum canal disponível!',
    this_card: 'Este é um cartão',
    course_no_available: 'Nenhum curso disponível!',
    exit_fullscreen: 'Sair do ecrã inteiro',
    bg_image: 'Imagem de fundo',
    introduction: 'Introdução',
    summary: 'Resumo',
    generate_introduction: 'Gerar introdução',
    generate_summary: 'Gerar resumo',
    bullet_points: 'Pontos-chave',
    title_simulation: 'Por favor, insira o nome da simulação',
    view_generated_images: 'Ver imagens geradas',
    image_transparency: 'Transparência da imagem',
    template_bg_color: 'Cor de fundo do modelo',
    select_template_layout: 'Selecionar layout do modelo',
    reload_template: '(Recarregar modelos)',
    are_you_sure_want_close: 'Tem a certeza de que quer fechar?',
    all_your_changes_will_be_lost: 'Todas as suas alterações serão perdidas.',
    please_checked_before_generated_video:
      'Por favor, confirme se todas as condições estão assinaladas antes de gerar o vídeo.',
    voice_must_be_selected: 'Uma voz deve ser selecionada',
    avatar_must_be_selected: 'Uma imagem de avatar deve ser selecionada.',
    maximum_five_slides_try_again:
      'Erro ao extrair imagens do ficheiro. Certifique-se de que o ficheiro tem no máximo 5 diapositivos e notas em cada um. Por favor, tente novamente!',
    back_to_upload: 'Voltar para o carregamento',
    uploading_file_to_server: 'A carregar o ficheiro para o servidor',
    extracting_images_from_your_file: 'A extrair imagens do seu ficheiro',
    upload_your_ppt_or_drag:
      'Carregue o seu ficheiro de apresentação (.PPTX) ou arraste-o para aqui.',
    maximum_five_slides_error:
      'Certifique-se de que o seu ficheiro PowerPoint contém no máximo 5 diapositivos com notas. Caso contrário, ocorrerá um erro.',
    number_of_questions_generated: 'Número de perguntas a gerar',
    quiz_page_this_cannot_be_done:
      'Tem a certeza de que quer adicionar o questionário nesta página? Isto não pode ser desfeito.',
    confirm_selection: 'Confirmar seleção',
    select_quiz_page: 'Selecionar página do questionário',
    lesson_do_you_want_add_this_quiz:
      'Em que parte da lição pretende adicionar este questionário?',
    beginning_of_lesson: 'No início da lição',
    end_of_lesson: 'No fim da lição',
    currently_active_page: 'Página ativa atualmente',
    finish: 'Concluir',
    upload_selection_file: 'Carregar ficheiro da secção',
    general_quiz: 'Questionário geral',
    manage_sequence: 'Gerir sequência',
    save_sequence: 'Guardar sequência',
    new: 'Novo',
    in_progress: 'Em progresso',
    recommended_course: 'Curso recomendado',
    up_coming: 'Brevemente',
    past_live: 'Transmissões passadas',
    input_your_channel_name: 'Por favor, insira o nome do seu canal!',
    organization_place: 'Mercado da organização',
    marketplace_report: 'Relatório do mercado',
    story_writing: 'Escrita de histórias',
    Ai_quiz: 'Questionário com IA',
    generate_quiz: 'Gerar questionário',
    create_story: 'Criar história',
    change_layout_page: 'Está prestes a alterar o layout desta página.',
    change_layout_message:
      'Atenção: apenas o texto, imagens, fundo e logótipo serão mantidos. Todos os outros elementos serão removidos.',
    reviews: 'Avaliações',
    tab_attachments: 'Anexos',
    zoom_in: 'Ampliar',
    zoom_out: 'Reduzir',
    zoom_reset: 'Repor zoom',
    no_attachment: 'Sem anexos.',
    select_upload_simulation: 'Por favor, selecione/carregue a simulação.',
    quiz_updated_successfully: 'Questionário atualizado com sucesso!',
    quizes: 'Questionários',
    trivia: 'Curiosidades',
    closing: 'A encerrar...',
    products: 'Produtos',
    ask_questions: 'Faça uma pergunta aqui...',
    course_information: 'Informações do Curso',
    course_assistance: 'Assistência ao Criador do Curso',
    go_back: 'Voltar',
    ai_generate_content_progress: 'Progresso da Geração de Conteúdo',
    view_generate_content: 'Ver Conteúdo Gerado',
    generate_error: 'Erro na Geração!',
    confirm_creating_course:
      'Você deseja confirmar a criação do curso com este conteúdo?',
    generate_content_automatically:
      'Isso adicionará automaticamente todo o conteúdo gerado como lições e páginas ao seu curso.',
    quiz_created_successfully: 'Quiz criado com sucesso!',
    create_quiz: 'Criar Quiz',
    quiz_setting: 'Configuração do Quiz',
    please_fill_quiz_setting:
      '* Por favor, preencha todos os campos nas configurações do Quiz',
    question_list: 'Lista de Perguntas',
    add_quiz_to_page: 'Adicionar Quiz à Página',
    form_create_question: 'Formulário de Criação de Pergunta',
    user_information_updated: 'Informações do Usuário Atualizadas!',
    your_stripe_activete_to_continue:
      'Sua conta Stripe está inativa. Por favor, conecte ou ative para continuar.',
    connect_tripe: 'Conectar Stripe',
    certificate_sent_sucessfully: 'Certificado enviado com sucesso por e-mail.',
    error_try_again: 'Erro. Tente novamente!',
    error_delete_channel: 'Erro ao excluir canal.',
    error_update_sub: 'Erro ao atualizar assinatura.',
    end_time_cannot_start:
      'O horário de término não pode ser anterior ao horário de início.',
    start_date_time_interval:
      'Intervalo de data e hora de início é obrigatório!',
    podcast_updated_successful: 'Podcast atualizado com sucesso.',
    podcast_created_successful: 'Podcast criado com sucesso.',
    podcast_published_successful: 'Podcast publicado com sucesso.',
    podcast_cover_updated: 'Capa do podcast atualizada.',
    new_podcast_details:
      'Um novo podcast será criado no atual com as novas informações inseridas.',
    current_update_podcast:
      'Atualizar podcast atual, músicas e detalhes de histórias.',
    create_new_podcast: 'Criar Novo Podcast',
    publish_podcast_public_view: 'Publicar podcast para visualização pública.',
    only_allowed_twenty_five_email: 'Somente 25 e-mails são permitidos.',
    only_allowed_five_email: 'Somente 5 e-mails são permitidos.',
    cover_is_required: 'Capa é obrigatória.',
    topic_is_required: 'Tópico é obrigatório.',
    delete_schedule: 'Excluir Agendamento',
    make_as_coaching: 'Marcar como Disponível para Coaching',
    manage_category: 'Gerenciar Categoria',
    threshold: 'Limite',
    threshold_popup:
      'Valor do limite em porcentagem (%), valor após o qual a recomendação é ativada para a categoria.',
    list_of_catagory: 'Lista de categorias',
    category_name: 'Nome da Categoria',
    category_threshold: 'Limite da Categoria',
    play_game: 'Jogar',
    switching_organization: 'Trocando de Organização...',
    coaching_session: 'Sessão de Coaching',
    required_channel_id: 'ID do canal é obrigatório!',
    error_occured_try_again: 'Ocorreu um erro. Tente novamente!',
    please_complete_marketplace_form:
      'Por favor, preencha o formulário do marketplace!',
    upload_file_corrupt: 'O arquivo enviado está corrompido.',
    course_not_published: 'O curso ainda não foi publicado!',
    error_request: 'Erro na solicitação. Por favor, tente novamente!',
    skill_request: 'Por favor, preencha os campos obrigatórios!',
    error_occured: 'Ocorreu um erro. Tente novamente!',
    show_time: 'Mostrar Hora',
    start_time: 'Hora de Início',
    end_time: 'Hora de Término',
    room_name: 'Nome do Podcast',
    add_guest_speaker: 'Adicionar Palestrante Convidado',
    cover_picture: 'Imagem da Capa',
    guest_speaker: 'Palestrante Convidado',
    see_more: 'Ver Mais',
    see_less: 'Ver Menos',
    background: 'Fundo',
    icon: 'Ícone',
    icon_size: 'Tamanho do Ícone',
    icon_color: 'Cor do Ícone',
    only_text: 'Apenas Texto',
    change_bg: 'Alterar Cor de Fundo',
    bg_color: 'Cor de Fundo',
    font_size: 'Tamanho da Fonte',
    normal: 'Normal',
    change_color: 'Alterar Cor do Texto',
    slant_text: 'Texto Inclinado',
    text_radius: 'Raio do Texto',
    vertical_align: 'Alinhamento Vertical',
    horizontal_align: 'Alinhamento Horizontal',
    change_icon_color: 'Alterar Cor do Ícone',
    upload_icon: 'Enviar Ícone',
    upload_signature: 'Enviar Assinatura',
    add_another_sign: 'Adicionar Outra Assinatura',
    name_badges: 'Nome dos Emblemas',
    should_less_150: 'deve ter 150 caracteres ou menos',
    your_badge: 'Seu Emblema',
    do_you_want_delete_badge: 'Deseja excluir este emblema?',
    do_you_want_delete_cert: 'Deseja excluir este certificado?',
    upload_logo: 'Enviar Logotipo',
    name_of_cert: 'Nome do Certificado',
    upload_cert: 'Atualizar Certificado',
    your_cert: 'Seu Certificado',
    translate_to: 'Traduzir para',
    select_file_attach: 'Selecione o Arquivo para Anexar',
    certificate: 'Certificado',
    badge: 'Emblema',
    publish_options: 'Opções de Publicação',
    publish_skills_journey: 'Publicar Jornada de Habilidades',
    videos: 'Vídeos',
    generate_ai_video:
      'O processo de geração de vídeo pode levar algum tempo. Você será notificado por e-mail quando estiver concluído.',
    trainer_information: 'Informações do Instrutor',
    promotional_video_link: 'Link do Vídeo Promocional',
    please_select: 'Por favor, selecione',
    image_name: 'Nome da Imagem:',
    image_size: 'Tamanho da Imagem:',
    charecters_fifteen_less: '15 caracteres ou menos',
    leadership: 'Liderança',
    text_arc: 'Arco de Texto',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    badge_history: 'Histórico de Emblemas',
    templates: 'Modelos',
    sign: 'Assinatura',
    logo: 'Logotipo',
    certificate_history: 'Histórico de Certificados',
    please_wait: 'Por favor, aguarde...',
    information: 'Informação',
    support_five_thousand_live_event:
      'Suporta até 5000 participantes para o evento',
    support_ten_live_event: 'Suporta até 10 participantes de vídeo ao vivo',
    we_will_back_participant:
      'Voltaremos com um evento com muitos participantes.',
    course_objectives: 'Objetivos do Curso',
    course_outlines: 'Estrutura do Curso',
    price_dollor: 'preço (usd)',
    not_completed: 'Não Concluído',
    enable_marketplace: 'Ativar Marketplace',
    enable_course_ai: 'Ativar Criação de Curso com IA',
    enable_report_to_admin: 'Ativar Relatórios para Administrador',
    enable_white_label: 'Ativar White Label',
    enable_eleven_labs_for_maze_play: 'Ativar Elevenlabs para Maze Play',
    enable_eleven_labs_for_maze_play_cloned: 'Ativar Voz Clonada do Elevenlabs',
    simulation_quiz: 'Quiz de Simulação',
    bg_color_setting: 'Configuração da Cor de Fundo',
    color_preview: 'Prévia da Cor',
    choose_new_color: 'Escolher Nova Cor',
    remove_color: 'Remover Cor',
    apply_color: 'Aplicar Cor',
    elemeent_in_a_sceenario_page:
      'Não é possível adicionar outro elemento em uma página de cenário. Tente outra página ou remova o cenário da página primeiro.',
    no_data_found: 'Nenhum dado encontrado.',
    references: 'Referências',
    open_file: 'Abrir Arquivo',
    showing_result: 'Exibindo Resultado:',
    fiften_day_free_trail: 'Teste Gratuito de 15 Dias',
    your_browser_does_not_support:
      'Seu navegador não suporta o elemento de áudio.',
    podcast_desc: 'Descrição do Podcast',
    input_podcast_desc: 'Por favor, insira a descrição do podcast',
    podcast_obj: 'Objetivos do Podcast',
    input_podcast_obj: 'Por favor, insira os objetivos do podcast',
    podcast_outline: 'Roteiro do Podcast',
    input_podcast_outline: 'Por favor, insira o roteiro do podcast',
    add_file: 'Adicionar Arquivo',
    generate_podcast_audio: 'Gerar Áudio do Podcast',
    generate_uploaded_file_input_parameter:
      'Gera o conteúdo com base nos arquivos enviados pelo usuário e os parâmetros fornecidos.',
    go_backe_generation_state: 'Voltar para o estado de geração de conteúdo.',
    create_ai_powered_podcast:
      'Criar episódio(s) de podcast com áudio gerado por IA.',
    generate_voice_for_all_podcast:
      'Por favor, gere a voz para todos os episódios do podcast',
    create_podcast_episode: 'Criar Episódio de Podcast',
    voice_name: 'Nome da Voz',
    input_custom_name: 'Por favor, insira um nome personalizado!',
    enter_custom_name: 'Digite o nome da voz personalizada',
    upload_complete: 'upload completo',
    uploading_in_progress: 'carregamento em andamento...',
    podcast_stream_content: 'Fluxo de Conteúdo do Podcast',
    upload_podcast_cover: 'por favor, envie a capa do podcast!',
    enter_podcast_name: 'Por favor, insira o nome do podcast!',
    podcast_topic: 'Tópico do Podcast',
    enter_podcast_topic: 'Por favor, insira o tópico do podcast!',
    enter_podcast_desc: 'Por favor, insira a descrição do podcast!',
    number_of_speaker: 'Número de Participantes',
    select_the_number_of_speaker:
      'Por favor, selecione o número de participantes!',
    number_of_episode: 'Número de Episódios',
    input_number_of_episode: 'Por favor, insira o número de episódios!',
    podcast_length: 'Duração do Podcast',
    select_the_podcast_length: 'Por favor, selecione a duração do podcast!',
    short_podcast: 'Curto (5-10 min)',
    medium_podcast: 'Médio (15-18 min)',
    long_podcast: 'Longo (18+ min)',
    name_of_host: 'Nome do Apresentador',
    enter_host_name: 'Por favor, insira o nome do apresentador!',
    guest_name: 'Nome dos Convidados',
    enter_guest_name: 'Por favor, insira o nome dos convidados!',
    choose_speaker_tone: 'Escolher Tom do Locutor',
    enter_speaker_tone: 'Por favor, selecione o tom do podcast!',
    informal: 'Informal',
    formal: 'Formal',
    serious: 'Sério',
    light_humor: 'Humor Leve',
    casual: 'Casual',
    select_content_source: 'Selecionar Fonte de Conteúdo',
    from_internet: 'Da Internet',
    upload_pdf_internet: 'Carregar um PDF ou Documento Interno',
    note: 'Nota:',
    podcast_content_will_be_automatically_generated:
      'O conteúdo do podcast será gerado automaticamente com base em fontes confiáveis da internet.',
    upload_or_select_file: 'Por favor, envie ou selecione arquivo(s)!',
    podcast_eposode_title: 'Título do Episódio do Podcast',
    enter_podcast_title: 'Por favor, insira o título do episódio!',
    podcast_episode_des: 'Descrição do Episódio do Podcast',
    enter_podcast_episode_des: 'Por favor, insira a descrição do episódio!',
    voice: 'Voz',
    music: 'Música',
    select_music: 'Selecionar música',
    play_the_music: 'Reproduzir música',
    stop_the_music: 'Parar música',
    context: 'Contexto',
    generate_audio_content_selected_voice:
      'Isso irá gerar o áudio do conteúdo de acordo com as vozes selecionadas.',
    required_field_before_submitting:
      'Por favor, preencha todos os campos obrigatórios antes de enviar.',
    regenerate_voice: 'Regenerar Voz',
    generate_voice: 'Gerar Voz',
    your_browser_does_not_suppot:
      'Seu navegador não suporta o elemento de áudio.',
    are_sure_leave_podcast: 'Tem certeza de que deseja sair do podcast?',
    broadcast_ongoing:
      'A transmissão está em andamento. Deseja realmente sair desta página?',
    brodcaster_unavailable: 'O transmissor está indisponível no momento.',
    setting_calender_for_booking: 'Configurando Calendário para Agendamento',
    add_calender: 'Adicionar Calendário',
    waiting_join_host: 'Aguardando o anfitrião entrar...',
    no_reviews_found: 'Nenhuma avaliação encontrada.',
    rated_already: 'Você já avaliou este evento ao vivo.',
    downlink_png: 'baixar_png',
    downlink_jpg: 'baixar_jpg',
    donwload_file_format:
      'Por favor, selecione o formato de arquivo que deseja baixar.',
    crashed_event:
      'Este evento falhou. Você precisa criar um novo evento. Desculpe pelo transtorno.',
    prompt: 'Prompt:',
    generated_image: '🚀 Gerando sua imagem... Por favor, aguarde.',
    download_add: 'Baixar tudo',
    setting_generator: 'Configurações do Gerador',
    enter_image_prompt: 'Por favor, insira um prompt de imagem',
    image_prompt: 'Insira seu prompt de imagem',
    negative_prompt: 'Prompt Negativo',
    negative_image_prompt: 'Insira seu prompt de imagem negativo',
    number_output: 'Número de Saídas',
    enter_number_output: 'Por favor, insira o número de saídas',
    image_style: 'Por favor, selecione o estilo da imagem',
    output_format: 'Formato de Saída',
    seeds: 'Sementes',
    enter_seeds: 'Por favor, insira o número de sementes',
    performance_mode: 'Modo de Desempenho',
    quality: 'Qualidade',
    speed: 'Velocidade',
    balanced: 'Equilibrado',
    guidance_scale: 'Escala de Orientação',
    enter_guidance: 'Por favor, insira a escala de orientação',
    select_image: 'Por favor, selecione a imagem.',
    image_prmt: 'Prompt de Imagem',
    generate_image_list_empty: 'A lista de imagens geradas está vazia.',
    knowledge_center_tooltrip_des:
      'Obtenha respostas concisas e contextualmente precisas para uma ampla variedade de perguntas, com base em informações gerais da internet geradas por um modelo de IA treinado com diversos textos online.',
    contexts: 'Contextos',
    ai_processing_video_sharebot:
      'O processamento de vídeo por IA levará cerca de 24 horas para ser concluído e aparecer no Sharebot.',
    remove_sharebot_video:
      'Se quiser remover a referência do vídeo ao Sharebot, exclua a transcrição correspondente junto com o vídeo.',
    remove_sharebot_video_audio:
      'Ao excluir a transcrição, a referência ao vídeo/áudio no Sharebot será removida, mas o vídeo ainda aparecerá na biblioteca de mídia/canal.',
    monthly_live_stream:
      'Para alterar seu limite mensal de transmissões ao vivo, entre em contato',
    monthly_transcribe_limit:
      'Para alterar seu limite mensal de transcrições, entre em contato',
    must_be_one_to_three_hundred: 'Deve estar entre 1 a 300 minutos.',
    all_field_required: 'Todos os campos são obrigatórios.',
    duration_minute: 'Duração (máximo 300 minutos)',
    gender: 'Gênero',
    select_gender: 'Selecionar Gênero',
    accent: 'Acento',
    select_accent: 'Selecionar Acento',
    create_voice: 'Criar Voz',
    enter_voice_name: 'Digite o Nome da Voz',
    select_voice_gender: 'Selecione o gênero da voz',
    upload_voice: 'Envie Sua Voz',
    upload_voice_mp_three: 'Envie sua voz (.mp3)',
    cloned_voice: 'Vozes Clonadas',
    voice_type: 'Tipo de Voz',
    select_voice_type: 'Selecione o Tipo de Voz',
    sharelook_stand: 'Padrão',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Personalizada (Clonagem de Voz)',
    create_auto_flow: 'Criar fluxo automático',
    how_many_layers: 'Quantas camadas',
    verify_selection: 'Verificar Seleção',
    uploaded_successful: 'Enviado com sucesso',
    upload_failed: 'Falha no envio',
    upload_only_five_mb: 'Carregar conteúdo (arquivos PDF, máx. 5)',
    docs_from_org_library: 'Usar Documento da Biblioteca da Organização',
    failed_maze_generate: 'Falha ao gerar labirinto. Tente novamente.',
    generate_metamaze: 'Gerando MetaMaze...',
    metamaze_being_generated:
      'Seu MetaMaze está sendo gerado. Você será notificado por e-mail quando o processo for concluído.',
    metamaze_generate_successfully: 'MetaMaze Gerado com Sucesso!',
    metamaze_with_proceed: 'Você pode prosseguir com o MetaMaze agora.',
    ai_metamaze_generate: 'Geração de MetaMaze com IA',
    what_kind_maze_create: 'Que tipo de labirinto você gostaria de criar?',
    manual_metamaze_creation: 'Criação Manual de MetaMaze',
    manually_maze_customizing_scnario:
      'Crie manualmente um labirinto personalizando o cenário e a árvore de opções',
    maze_ai_generated: 'Gerar labirinto automaticamente com IA',
    unmark_deadend: 'Desmarcar como beco sem saída',
    mark_deadend: 'Marcar como beco sem saída',
    select_multiple_image_for_scenario:
      'Você pode selecionar várias imagens para o cenário.',
    select_your_image: 'Imagens selecionadas',
    click_to_preview: 'Clique para visualizar',
    are_you_sure_delete_image: 'Tem certeza de que deseja excluir esta imagem?',
    select_image_from_library: 'Selecionar imagem da Biblioteca de Mídia',
    uploading_video: 'Enviando vídeo...',
    tree_node_type: 'Tipo de Nó da Árvore',
    correct_option_scenario: 'Opção Correta ou Cenário',
    incorrect_option: 'Opção Incorreta',
    option_scenario_without_text: 'Opção ou Cenário sem texto',
    dead_end: 'Beco Sem Saída (Borda Vermelha)',
    correct_path: 'Caminho Correto',
    incorrect_path_not_selected_correct_option_path:
      'Caminho Incorreto / Caminho onde a opção correta não foi selecionada.',
    double_click_on_tree_node:
      'Ao clicar duas vezes em um nó da árvore, o editor de texto rolará automaticamente até o conteúdo daquele nó.',
    add_scenario: 'Adicionar Cenário',
    add_option: 'Adicionar Opção',
    an_error_occured: 'Ocorreu um erro:',
    download_summary: 'Baixar Resumo',
    step_wise_analysis: 'Análise Passo a Passo',
    step: 'Passo',
    upload_csv_file: 'Enviar Arquivo CSV',
    download_template_to_import: 'Baixar modelo de exemplo para importar',
    please_input_email: 'Por favor, insira um e-mail.',
    email_at_least_three_characters:
      'O e-mail deve ter pelo menos 3 caracteres.',
    email_cannot_be_empty: 'O e-mail não pode estar vazio.',
    input_email_in_new_line: 'Insira e-mails (um por linha)',
    role: 'Função',
    select_role: 'Por favor, selecione uma função',
    select_group: 'Por favor, selecione um grupo',
    identification_number: 'Número de Identificação (Opcional)',
    add_identification_number: 'Por favor, adicione um número de identificação',
    pie_chart_of_all_categories:
      'Gráfico de pizza de todas as categorias com base em seu uso no Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Total de perguntas do ShareSphere respondidas pelos usuários da organização atual, com estas categorias e seus respectivos resultados de sucesso e falhas.',
    voice_style_over_the_text:
      'Onde você pode usar vários estilos de voz sobre o texto digitado bla bla bla Lorem Ipsum é simplesmente um texto fictício da indústria de impressão e composição. Lorem Ipsum é o texto fictício padrão da indústria desde 1500.',
    input_your_question: 'Digite sua pergunta!',
    make_me_sales_manager: 'ex: O que pode me tornar um gerente de vendas',
    enter_the_number_relevant_document:
      'Digite o número de documentos relevantes',
    please_wait_loading_result:
      'Por favor, aguarde carregando os resultados...',
    no_result_found: 'Nenhum resultado encontrado. Tente fazer outra pergunta',
    browser_doesnot_support_iframes: 'Seu navegador não suporta iframes',
    total_duration: 'Duração Total',
    number_of_messages: 'Número de Mensagens',
    search_result: 'Resultados da busca',
    count_result: '(1244 resultados)',
    your_other_interests: 'Seus outros interesses',
    your_total_score: 'Sua Pontuação Total',
    add_a_question: '+adicionar uma pergunta',
    travia_question_empty: 'A lista de perguntas do Travia está vazia.',
    video_generation_is_on_queue: 'A geração do seu vídeo está na fila!',
    checking_video_status: 'Verificando status do vídeo...',
    total_quizzes: 'Total de Questionários',
    number_of_votes: 'Número de Votos',
    total_events: 'Total de Eventos',
    number_of_rates: 'Número de Avaliações',
    number_of_likes: 'Número de Curtidas',
    all_courses: 'Todos os Cursos',
    total_questions: 'Total de Perguntas',
    no_skill_journey: 'Nenhuma jornada de habilidade disponível!',
    search_no_results: '- nenhum resultado disponível!',
    no_image_generated: 'Nenhuma Imagem Gerada!',
    all_topic_in_this_lesson:
      'Todos os tópicos desta lição serão excluídos. Isso não pode ser desfeito.',
    content_has_been_generated: 'Conteúdo gerado para este tópico.',
    update_course_template: 'Atualizar Modelo de Curso',
    add_course_template: 'Adicionar Modelo de Curso',
    create_course_now: 'Criar Curso Agora',
    preview_course: 'Pré-visualizar Curso',
    layout: 'Layout',
    import_from_youtube: 'Importar do YouTube',
    my_media_library: 'Minha Biblioteca de Mídia',
    bg_added: 'Plano de fundo adicionado',
    add_bg: 'Adicionar Plano de Fundo',
    booked_schedule: 'Agenda Reservada',
    add_schedule: 'Adicionar Agenda',
    are_you_delete_schedule: 'Tem certeza de que deseja excluir esta agenda?',
    add_task: 'Adicionar Tarefa',
    update_calender: 'Atualizar Calendário',
    manage_cookies: 'Gerenciar Cookies',
    cookie_banner_text:
      'Usamos cookies para melhorar sua experiência de navegação, analisar o tráfego do site e personalizar o conteúdo. Sua privacidade é importante para nós.',
    accept_all_cookies: 'Aceitar Todos os Cookies',
    reject_all: 'Rejeitar Todos',
    customize: 'Personalizar',
    cookie_preferences_title:
      'Preferências de Cookies & Configurações de Privacidade',
    privacy_subtitle:
      'Sua privacidade é importante para nós. Escolha quais cookies você deseja aceitar. Você pode alterar essas configurações a qualquer momento.',
    save_choices: 'Salvar Minhas Escolhas',
    strictly_necessary: 'Estritamente Necessário',
    strictly_necessary_desc:
      'Estes cookies são essenciais para o funcionamento adequado do site. Eles habilitam funcionalidades básicas, como navegação de páginas, envio de formulários e acesso a áreas seguras. O site não pode funcionar corretamente sem eles.',
    analytics_performance: 'Analytics & Desempenho',
    analytics_performance_desc:
      'Estes cookies nos ajudam a entender como os visitantes interagem com nosso site, coletando e relatando informações anonimamente. Isso nos ajuda a melhorar o desempenho do site e a experiência do usuário.',
    advertising_marketing: 'Publicidade & Marketing',
    advertising_marketing_desc:
      'Estes cookies são usados para tornar as mensagens publicitárias mais relevantes para você. Eles evitam que o mesmo anúncio apareça repetidamente e garantem que os anúncios sejam exibidos corretamente para os anunciantes.',
    tracking_social: 'Rastreamento & Mídia Social',
    tracking_social_desc:
      'Estes cookies permitem funcionalidades avançadas e personalização, como recursos de mídia social e conteúdo personalizado. Podem ser definidos por nós ou por provedores de terceiros.',
    functional: 'Funcional',
    functional_desc:
      'Estes cookies habilitam funcionalidades avançadas, como suporte via chat, ajuda ao vivo e outros recursos interativos que melhoram sua experiência em nosso site.',
    your_rights: 'Seus Direitos:',
    rights_description:
      'Você pode retirar seu consentimento a qualquer momento, acessar seus dados ou solicitar sua exclusão a qualquer momento.',
    withdraw_consent: 'Retirar Todo Consentimento',

    how_many_options: 'Quantas opções',
    add_content: 'Adicionar Conteúdo',
    downloads_center: 'Centro de Downloads',
    sharelook_help_center: 'Central de Ajuda Sharelook',
    channel_outline: 'Resumo do Canal',
    channel_objectives: 'Objetivos do Canal',
    no_sop_available: 'Nenhuma lista de SOP disponível.',
    generate_world_summary: 'Gerar Cenário',
    world_scenario: 'Cenário do Mundo Real',
    drag_icon_hint: 'Dica: Arraste o ícone para o canvas para posicioná-lo',
    drag_text_hint: 'Dica: Arraste o texto para o canvas para posicioná-lo',
    edit_badge: 'Editar Emblema',
    create_new_badge: 'Novo Emblema',
    select_video_preview: 'Selecione um vídeo para visualização',
    certificate_title_required: 'Título do Certificado é obrigatório',
    discard_changes: 'Descartar Alterações',
    edit_certificate: 'Editar Certificado',
    add_another_logo: 'Adicionar Outro Logo',
    optional: 'Opcional',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Criar Nova Tarefa',
    quest_filter_title: 'Tarefa',
    sharelook_assistance: 'Assistência Sharelook',
    upload_scorm_zip: 'Carregar SCORM Zip',
    only_letters_numbers_space_dot_allowed:
      'Apenas letras, números, espaços e pontos são permitidos!',
    video_playing: 'Reproduzindo',
    course_price_message: `*O curso será publicado apenas para usuários dentro da organização e não pode ser revendido no marketplace.`,
    lesson_must_be_positive: 'O número de aulas deve ser maior que 1',
    btn_proceed: 'Prosseguir',
    rule_select_music: 'Por favor, selecione música',
    course_info: 'Informações do Curso',
    content_selection: 'Seleção de Conteúdo',
    course_content_source: 'Fonte de Conteúdo do Curso',
    choose_how_to_source: 'Escolha como obter conteúdo para este curso:',
    automatic_selection: 'Seleção Automática',
    system_will_automatically_select_relavant_documents:
      'O sistema selecionará automaticamente os documentos relevantes da sua biblioteca',
    manual_selection: 'Seleção Manual',
    choose_specific_documents_from_your_library:
      'Escolha documentos específicos da sua biblioteca',
    upload_files: 'Carregar Arquivos',
    upload_new_documents:
      'Carregar novos documentos (PDF, DOC, DOCX, PPT, PPTX, TXT) - Máximo 5 arquivos',
    file: 'arquivo',
    ready_to_upload: 'pronto para carregar',
    clear_all: 'Limpar Tudo',
    confirm_course_wide_premiew: 'Confirmar Visualização de Todo o Curso',
    generate_course_preview: 'Gerar Pré-visualização do Curso',
    instructions_across_the_course_to_generate:
      'Aplicaremos suas instruções em todo o curso para gerar uma pré-visualização. Revise tudo antes de decidir manter ou descartar alterações.',
    instruction_to_preview_course_wide:
      'Instruções para pré-visualização de todo o curso:',
    edit_content: 'Editar Conteúdo',
    manage_course_template: 'Gerenciar Modelo do Curso',
    undo: 'Desfazer',
    apply_changes: 'Aplicar Alterações',
    characters: 'caracteres',
    apply_all: 'Aplicar Tudo',
    apply_to_all: 'Aplicar a Todos',
    use_this_content: 'Usar Este Conteúdo',
    original: 'Original',
    edited: 'Editado',
    edited_content_preview: 'Pré-visualização do Conteúdo Editado',
    apply_edits_to_all_topices: 'Aplicar edições a todos os tópicos?',
    current_editing_instructions_across_the_whole_course:
      'Isso aplicará suas instruções de edição atuais em todo o curso. Você pode revisar a pré-visualização combinada antes de salvar.',
    edit_content_instructions: 'Instruções para Editar Conteúdo',
    generate_content_for_this_topic_instruction:
      'Gerar conteúdo para este tópico usando suas instruções',
    descrip_edit_content:
      'Descreva como editar este conteúdo (por exemplo: resumir, simplificar, reescrever)',
    try_short_clear_direcctives: `Tente instruções curtas e claras. Exemplos: “reduzir para 100 palavras, manter pontos principais”, “simplificar linguagem”, “tornar mais conciso e remover excesso”.`,
    we_preserve_the_core_meaning:
      'Preservamos o significado principal ao aplicar suas instruções.',
    feedback_optional: 'Feedback (Opcional)',
    write_your_feedback_here: 'Escreva seu feedback aqui',
    from_web: 'Da Web',
    from_desktop: 'Do Desktop',
    pleae_wait_processing: 'Por favor, aguarde, processando...',
    create_simulation_from_screen_capture:
      'Criar Simulação a partir da Captura de Tela',
    sharelook_not_found: 'ShareLook Não Encontrado',
    sharelook_screen_capture_application_not_be_opened:
      'O aplicativo ShareLook de captura de tela não pôde ser aberto. Pode não estar instalado em seu computador.',
    download_sharelook: 'Baixar ShareLook',
    launch_sharelook_application: 'Abrir Aplicativo ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Isso abrirá o aplicativo ShareLook para captura de tela.',
    sharelook_dosenot_open:
      'Se o ShareLook não abrir, pode não estar instalado em seu computador.',
    open_sharelook: 'Abrir ShareLook',
    download_app: 'Baixar Aplicativo',
    background_image_setting: 'Configurações da Imagem de Fundo',
    current_image: 'Imagem Atual',
    change_image: 'Alterar Imagem',
    remove_image: 'Remover Imagem',
    no_background_image_selected: 'Nenhuma imagem de fundo selecionada',
    add_image: 'Adicionar Imagem',
    this_will_open_for_screen_recording:
      'Isso abrirá o aplicativo ShareLook para gravação de tela.',
    ai_image_generation: 'Geração de Imagem por IA',
    image_edit: 'Editar Imagem',
    text_to_image: 'Texto para Imagem',
    output_gallary: 'Galeria de Saída',
    instant_generation: 'Pronto para geração instantânea',
    prompt_and_unleash_the_power: 'Insira seu prompt e libere o poder',
    use_this_image: 'Usar Esta Imagem',
    error_generating: 'Erro ao gerar.',
    generation_tips: 'Dicas de Geração',
    detailed_descriptions_for_more_accurate_results:
      'Use descrições detalhadas para resultados mais precisos',
    reference_image: 'Imagem de Referência',
    select_pixel_image: 'Selecionar Imagem Pixel',
    max_mb: 'Máx. 50MB',
    please_enter_text_to_appear_image: 'Insira o texto que aparecerá na imagem',
    enter_text_to_apear_in_the_image: 'Insira o texto que aparecerá na imagem',
    generate_image: 'Gerar Imagem',
    prompt_assistant: 'Assistente de Prompt',
    generate_image_using_suggested_prompt:
      'Gerar Imagem Usando Prompt Sugerido',
    talk_to_ai_about_the_image_generate:
      'Converse com a IA sobre a imagem que deseja gerar',
    ask_for_prompt_suggestions: 'Pedir sugestões de prompt...',
    enter_a_search_term_to_find_stock_images:
      'Digite um termo de pesquisa para encontrar imagens de stock',
    choose_your_content_source: 'Escolha sua fonte de conteúdo:',
    upload_new_document_from_your_device:
      'Carregar novos documentos do seu dispositivo',
    automatic_library_selection: 'Seleção Automática da Biblioteca',
    system_automatically_selects_relevant_document:
      'O sistema seleciona automaticamente documentos relevantes',
    manual_library_selection: 'Seleção Manual da Biblioteca',
    generate_content: 'Gerar Conteúdo',
    add_to_current_page: 'Adicionar à Página Atual',
    generate_bullet_points: 'Gerar Tópicos',
    generating: 'Gerando',
    this_may_take_a_few_moments: 'Isso pode levar alguns instantes',
    apply_to_page: 'Aplicar à Página',
    scenario_escription: 'Descrição do Cenário:',
    feedback: 'Feedback',
    form_mode: 'Modo de Formulário',
    chat_mode: 'Modo de Chat',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Isto irá gerar uma continuação da história selecionada usando IA.',
    continue_this_story_question: 'Continuar esta história?',
    continue_this_story: 'Continuar esta história',
    what_will_happen: 'O que acontecerá:',
    the_ai_will_analyze_the_existing_story_content:
      'A IA analisará o conteúdo existente da história',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Gerar uma continuação natural que siga o mesmo tom e estilo',
    create_new_content_that_build_upon_the_current_narrative:
      'Criar novo conteúdo que se baseie na narrativa atual',
    this_process_may_take_a_few_moments_to_complete:
      'Este processo pode levar alguns instantes para ser concluído.',
    no_existing_stories_found_for_this_course:
      'Nenhuma história existente encontrada para este curso.',
    create_your_first_story: 'Crie sua primeira história',
    existing_stories: 'Histórias existentes',
    create_new_story: 'Criar nova história',
    tone: 'Tom',
    style: 'Estilo',
    genre: 'Gênero',
    loading_your_stories: 'Carregando suas histórias...',
    edit_story: 'Editar história',
    story_preferences: 'Preferências da história',
    please_input_your: 'Por favor insira seu',
    add_character_names_and_press_enter:
      'Adicione nomes de personagens e pressione Enter',
    select_or_type_your: 'Selecione ou digite seu',
    enter_your: 'Digite seu',
    position_of_the_story_in_the_lesson:
      'A posição da história na lição. A história será adicionada como um bloco na posição especificada.',
    save_previous_content_on_the_pages: 'Salvar conteúdo anterior nas páginas',
    the_existing_content_in_the_selected_pages:
      'O conteúdo existente nas páginas selecionadas será substituído pela história gerada.',
    real_world_scenario: 'Cenário do mundo real',
    add_optional_instructions:
      'Adicionar instruções opcionais (tom, duração, público, etc.)',
    ready_to_enerate_your_real_world_scenario:
      'Pronto para gerar seu cenário do mundo real',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Clique em "Gerar Cenário do Mundo Real" para criar um cenário realista baseado no conteúdo da sua lição.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'A IA analisará o tema e o conteúdo da sua lição',
    generate_a_practical_real_world_scenario:
      'Gerar um cenário prático do mundo real',
    you_can_then_edit_and_customize_the_result:
      'Você pode então editar e personalizar o resultado',

    add_it_as_a_new_page_to_your_lesson:
      'Adicione como uma nova página à sua lição',
    regenerate_with_instructions: 'Regenerar com instruções',
    add_real_world_scenario: 'Adicionar Cenário do Mundo Real',
    generate_real_world_scenario: 'Gerar Cenário do Mundo Real',
    simulation_has_been_stopped: 'A simulação foi interrompida!',
    loading_simulation: 'Carregando simulação...',
    you_have_exhausted_all_the_attempts: 'Você esgotou todas as tentativas',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Estude o cenário nesta página e selecione a resposta correta nas opções abaixo.',
    attempts_limit_reached:
      'Limite de tentativas atingido. Você pode jogar novamente, mas sua pontuação não será salva.',
    play_again: 'Jogar novamente',
    import_music_from_computer: 'Importar música do computador.',
    more: 'mais',
    no_badge_yet: 'Nenhum distintivo ainda',
    competition_filter: 'Filtro de Competição',
    global_leaderboard: 'Classificação Global',
    placeholder_for_the_global_leaderboard:
      'Este é um espaço reservado para o Classificação Global.',
    badge_editor: 'Editor de Distintivos',
    adjust_the_appearance_of_this_badge_icon:
      'Ajuste a aparência deste ícone de distintivo. As alterações se aplicam apenas a este distintivo.',
    badge_style: 'Estilo do Distintivo',
    the_image_must_be_pixels: 'A imagem deve ter 200x200 pixels.',
    badge_name: 'Nome do Distintivo',
    badge_descrription: 'Descrição do Distintivo',
    enter_badge_criteria: 'Digite os critérios do distintivo',
    discard: 'Descartar',
    badge_enable: 'Distintivos Habilitados',
    award_users_with_badges_to_highlight_the_milestones:
      'Premie os usuários com distintivos para destacar os marcos na jornada de aprendizado deles.',
    badge_types: 'Tipos de Distintivos',
    enable_or_disable_specific_badge_types_for_your_users:
      'Habilite ou desabilite tipos específicos de distintivos para seus usuários.',
    levels_enabled: 'Níveis Habilitados',
    level_rules: 'Regras de Nível',
    points: 'Pontos',
    add_new_level: 'Adicionar Novo Nível',
    add_level: 'Adicionar Nível',
    points_enabled: 'Pontos Habilitados',
    learning_activities_and_encourage_healthy_competition:
      'Premie usuários com pontos por diferentes atividades de aprendizado e incentive a competição saudável.',
    award_points: 'Premiar Pontos',
    the_following_equates_the_value_of_one_item_completion:
      'O seguinte equivale ao valor da conclusão de um item',
    general: 'Geral',
    others: 'Outros',
    certificate: 'Certificado',
    quiz_passed: 'Quiz aprovado',
    tip_approved: 'Dica aprovada',
    tip_liked: 'Dica curtida',
    rewards: 'Recompensas',
    offer_discounts_when_learners_achieve:
      'Ofereça descontos quando os aprendizes alcançarem um conjunto de pontos, distintivos ou níveis.',
    give_rewards: 'Dar Recompensas',
    discount_course_purchases_by: 'Descontar compras de cursos em',
    with_points_more_than: 'com pontos acima de',
    with_badges_more_than: 'com distintivos acima de',
    with_level_upwards_more_than: 'com nível acima de',
    leaderboard: 'Classificação',
    leaderboard_enabled: 'Classificação Habilitada',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'As classificações oferecem aos usuários uma visão geral de seu progresso de aprendizado em pontos em comparação com os demais.',
    show_levels: 'Mostrar Níveis',
    show_points: 'Mostrar Pontos',
    show_badges: 'Mostrar Distintivos',
    show_courses: 'Mostrar Cursos',
    show_certificates: 'Mostrar Certificados',
    leaderboard_settings: 'Configurações da Classificação',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Configure experiências envolventes de classificação para aumentar a motivação do aprendiz.',
    award_users_with_points_for_different_learning_activities:
      'Premie os usuários com pontos por diferentes atividades de aprendizado.',
    badge_set: 'Conjunto de Distintivos',
    choose_the_type_of_badges_your_users:
      'Escolha o tipo de distintivos que seus usuários ganharão durante o aprendizado.',
    levels: 'Níveis',
    Levels_represent_the_stages:
      'Os níveis representam os estágios na jornada de aprendizado de um usuário.',
    enabled: 'Habilitado',
    disabled: 'Desabilitado',
    quick_select: 'Seleção Rápida',
    yesterday: 'Ontem',
    last_week: 'Semana passada',
    Last_month: 'Mês passado',
    last_quarter: 'Último trimestre',
    historical_leaderboard: 'Classificação Histórica',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Acompanhe seu desempenho e veja como você se classifica entre seus colegas',
    time_period: 'Período',
    page_of: 'Página 1 de 1',
    edit_competition: 'Editar Competição',
    create_competition: 'Criar Competição',
    arrow_right: 'seta-direita',
    update_competition: 'Atualizar Competição',
    competition_title: 'Título da Competição',
    enter_competition_title: 'Digite o título da competição',
    enter_competition_description: 'Digite a descrição da competição',
    leaderboard_skill: 'Habilidade',
    select_a_skill: 'Selecione uma habilidade',
    no_skills_found: 'Nenhuma habilidade encontrada',
    competition_period: 'Período da Competição',
    add_badge_rule: 'Adicionar Regra de Distintivo',
    create_badge: 'Criar Distintivo',
    add_level_rule: 'Adicionar Regra de Nível',
    selected_participants: 'Participantes Selecionados',
    no_participants: 'Nenhum participante',
    start_end_date: 'Data de Início–Fim',
    created_date: 'Criado por',
    new_competition: 'Nova Competição',
    competitions_list: 'Lista de Competições',
    search_competitions: 'Pesquisar competições...',
    are_you_sure_you_want_to_delete_the_competition:
      'Tem certeza de que deseja excluir a competição',
    history: 'Histórico',
    export: 'Exportar',
    search_by_name: 'Pesquisar por nome...',
    no_historical_data_available_for_the_selected_period:
      'Nenhum dado histórico disponível para o período selecionado.',
    no_leaderboard_data_available: 'Nenhum dado de classificação disponível.',
    competitions: 'Competições',
    leaderboards: 'Classificações',
    welcome_back: 'Bem-vindo de volta',
    track_your_performance_and_see:
      'Acompanhe seu desempenho e veja seu ranking',
    team_leaderboard: 'Classificação da Equipe',
    try_again: 'Tente novamente',
    no_competitions_for_search: 'Nenhuma competição disponível para',
    no_competitions_available: 'Nenhuma competição disponível',
    no_competitions_matching_search:
      'Nenhuma competição encontrada correspondendo à sua pesquisa. Tente ajustar os termos de pesquisa ou verifique novamente mais tarde.',
    no_competitions_general:
      'Atualmente não há competições configuradas. Verifique mais tarde ou contate seu administrador para criar novas competições.',
    media_management: 'Gerenciamento de Mídia',
    badgess_set: 'Conjunto de Distintivos',
    choose_the_default_visual_style_for_badge:
      'Escolha o estilo visual padrão dos ícones de distintivo usados na plataforma.',
    enable_badges: 'Ativar Distintivos',
    add_badge: 'Adicionar Distintivo',
    min: 'Mín',
    max: 'Máx',
    your_rank: 'Seu ranking',
    your_points: 'Seus pontos',
    your_level: 'Seu nível',
    rank: 'Ranking #',
    level: 'Nível',
    progress: 'Progresso',
    new_folder: 'Nova Pasta',
    file_upload: 'Enviar Arquivo',
    writer: 'Escritor',
    text_documents: 'Documentos de Texto',
    spreadsheets: 'Planilhas',
    impress: 'Apresentação',
    presentations: 'Apresentações',
    capture_desktop_screen: 'Capturar Tela do Desktop',
    capture_desktop_screens: 'Capturar Telas do Desktop',
    your_documents: 'Seus Documentos',
    manage_your_videos_images_audio_files:
      'Gerencie seus vídeos, imagens, arquivos de áudio e outros recursos usados na criação de conteúdo.',
    your_organization_documents: 'Documentos da sua Organização',
    keep_your_organization_creative_assets_organized:
      'Mantenha os ativos criativos da sua organização organizados e acessíveis—otimize o trabalho em equipe e a produção de conteúdo.',
    your_public_documents: 'Seus Documentos Públicos',
    curated_collection_of_media_assets_available:
      'Uma coleção curada de recursos de mídia disponível para todos—explore, reutilize e crie.',
    your_download_center_documents: 'Documentos do seu Centro de Download',
    repository_of_approved_media_assets_for_download:
      'Um repositório de recursos de mídia aprovados para download e uso em seus projetos.',
    search_files_and_folders: 'Pesquisar arquivos e pastas..',
    home: 'Início',
    folders: 'Pastas',
    folder_name: 'Nome da Pasta',
    owner: 'Proprietário',
    last_updated: 'Última Atualização',
    action: 'Ação',
    no_folders_found: 'Nenhuma pasta encontrada',
    files: 'Arquivos',
    enabling_ai: 'Habilitando IA...',
    rename: 'Renomear',
    copy: 'Copiar',
    move: 'Mover',
    verson_history: 'Histórico de Versões',
    manage_permission: 'Gerenciar Permissão',
    generate_audit_report: 'Gerar Relatório de Auditoria',
    last_edited: 'Última edição',
    no_files_found: 'Nenhum arquivo encontrado',
    are_you_sure_you_want_to_make_this_item_public:
      'Tem certeza de que deseja tornar este item público? Ele será copiado para sua biblioteca pública.',
    move_to_organization: 'Mover para Organização',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Tem certeza de que deseja copiar este item para a biblioteca da sua organização?',
    are_you_sure_you_want_to_make_this_item_private:
      'Tem certeza de que deseja tornar este item privado? Ele será copiado para sua biblioteca pessoal.',
    date_modified: 'Data de Modificação',
    workflow_management: 'Gerenciamento de Fluxo de Trabalho',
    configure_editors_approvers_and_viewers_for_this_document:
      'Configure editores, aprovadores e visualizadores para este documento.',
    error_Loading_editor: 'Erro ao carregar o editor',
    debug_info: 'Informações de Depuração',
    loading_editor: 'Carregando Editor...',
    submitted_for_review: 'Enviado para Revisão',
    editors: 'Editores',
    no_editors_added_yet:
      'Nenhum editor adicionado ainda. Clique em "Adicionar Editor" para adicionar.',
    add_editor: 'Adicionar Editor',
    approvers: 'Aprovadores',
    no_approvers_added_yet:
      'Nenhum aprovador adicionado ainda. Clique em "Adicionar Aprovador" para adicionar.',
    add_approvers: 'Adicionar Aprovador',
    viewer: 'Visualizador',
    no_viewers_added_yet:
      'Nenhum visualizador adicionado ainda. Clique em "Adicionar Visualizador" para adicionar.',
    add_viewer: 'Adicionar Visualizador',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Tem certeza de que deseja excluir os itens selecionados?'
  },
  v3: {
    reportShareSphere: 'Compartilhar Esfera',
    overview: 'Visão Geral da Categoria',
    triviaReport: 'Categoria da Esfera Compartilhada',
    overviewGraph: 'Gráfico da Visão Geral da Categoria',
    category: 'Categoria',
    phCategory: 'Selecionar Categoria',
    podcast: 'Podcast, Música e Histórias',
    pastPodcast: 'Podcasts Passados',
    upcomingPodcast: 'Podcasts Fututos',
    podcastLanguageTitle: 'Idioma do Podcast, Música e Histórias',
    podcastLanguageCheckbox: 'Usar IA para o idioma do meu podcast',
    howRate: 'Como você avalia este podcast?',
    podcastSubmit: 'Enviar',
    podcastGuest: 'Palestrante Convidado:',
    podcastReview: 'Avaliações',
    podcastEpishode: 'Episódio',
    podcastEnd: 'Podcast Encerrado',
    date_podcast: 'Data do Podcast',
    skill_not_found: 'Desculpe! Jornada de habilidades não encontrada.',
    coaching: 'Treinamento',
    webinar: 'Webinar',
    public_conference: 'Conferência Pública',
    skill_journey_subtitle:
      'Configure sua jornada de habilidades e escolha quem pode visualizar e interagir com ela.',
    enable_white_label: 'Ativar White Label',
    create_new_event_org: 'Criar novo evento para sua organização',
    create_new_event_marketplace: 'Criar novo evento para o marketplace',
    create_new_event_both:
      'Criar novo evento para sua organização e marketplace',
    event_outline: 'Insira o esboço do evento',
    event_obj: 'Insira os objetivos do evento',
    event_description: 'Insira a descrição do evento',
    create_new_metamaze_org: 'Criar novo MetaMaze para sua organização',
    create_new_metamaze_marketplace: 'Criar novo MetaMaze para o marketplace',
    create_new_metamaze_both:
      'Criar novo MetaMaze para sua organização e marketplace',
    add_key_words: 'Adicionar palavras-chave',
    press_enter_make_keyword: 'Pressione Enter para criar palavra-chave',
    disable_skip_quiz: 'Desabilitar pular quiz',
    warning_complete_quiz: 'Por favor, complete o quiz para continuar.',
    signup_email_verification:
      'Enviamos um link de verificação para o seu e-mail. Por favor, acesse o link para verificar seu cadastro.',
    verifying_registration: 'Verificando registro da conta...',
    reset_password_linK:
      'Enviamos um link para redefinir sua senha ao seu e-mail. Por favor, acesse o link para configurar uma nova senha.',
    reset_email_error:
      'Usuário não encontrado para esse e-mail, tente usar o nome de usuário!',
    first_name: 'Nome',
    last_name: 'Sobrenome',
    error_firstName: 'Por favor, insira seu nome',
    error_sharebot_organization: 'Por favor, insira sua organização',
    error_lastName: 'Por favor, insira seu sobrenome',
    private_conference: 'Conferência Privada',
    public_conference: 'Conferência Pública',
    discussion_room: 'Sala de Discussão',
    training_no_courses:
      'Você não está participando de nenhum curso atualmente.',
    training_no_events:
      'Você não está participando de nenhum evento atualmente.',
    allow_sharing_trainer_info:
      'Permitir que o marketplace compartilhe o endereço de e-mail',
    error_username_space: 'O nome de usuário não pode conter espaços.',
    error_sharebot_organization_space:
      'O nome da organização não pode conter espaços.',
    edit_permission: 'Permissão para editar',
    valid_price: 'O preço deve ser maior que 0',
    course_price_message: `*Cursos são abertos apenas para usuários que compraram via organização e não podem ser revendidos no marketplace`,
    valid_edit_price: 'O preço de edição deve ser menor que o preço de compra.',
    my_calendar: 'Meu Calendário',
    error_valid_firstName: 'Por favor, insira um nome válido.',
    error_valid_organization:
      'Por favor, insira um nome de organização válido.',
    error_valid_lastName: 'Por favor, insira um sobrenome válido.',
    error_name_spaces: 'O nome não pode conter espaços',
    items: 'Itens',
    publish_to_channel: 'Publicar na minha coleção de canais',
    create_a_channel: 'Criar meu canal',
    create_a_trivia: 'Criar quiz',
    create_a_new_channel: 'Criar novo canal',
    add_videos: 'Adicionar vídeos',
    save_and_continue: 'Salvar e continuar',
    channel: 'Canal',
    channels: 'Canais',
    view_channel: 'Visualizar canal',
    edit_channel: 'Editar canal',
    delete_channel: 'Excluir canal',
    my_video_channels: 'Meus canais de vídeo',
    training_no_channel:
      'Você não está participando de nenhum canal atualmente.',
    monthly_price_required: 'Preço mensal obrigatório',
    yearly_price_required: 'Preço anual obrigatório',
    one_time_price_required: 'Preço único obrigatório',
    marketplace_quantity: 'Dólares',
    report_webinar: 'Webinar',
    report_coaching: 'Treinamento',
    report_channel: 'Canal',
    report_public_conference: 'Conferência Pública',
    report_maze: 'Labirinto',
    channel: 'Canal',
    edit_price: 'Editar preço ($)',
    quantity: 'Quantidade',
    payment_type: 'Tipo de pagamento',
    total_amount: 'Valor total ($)',
    net_amount: 'Valor líquido ($)',
    edit_option: 'Editar opção',
    marketplace_price: 'Preço ($)',
    market_name: 'Nome',
    duration_min: 'Duração (minutos)',
    users_total: 'Usuários (total)',
    sales_total: 'Total de vendas (dólares)',
    search_coaching: 'Buscar treinamento',
    search_channel: 'Buscar canal',
    search_webinar: 'Buscar webinar',
    search_maze: 'Buscar labirinto',
    search_public_conference: 'Buscar conferência pública',
    buyer_type: 'Tipo de comprador',
    quanity: 'Quantidade',
    channel_unit_amount: 'Valor líquido ($)',
    channel_updated_at: 'Atualizado em',
    month_price: 'Preço (mês)',
    year_price: 'Preço (ano)',
    one_time_price: 'Preço (único)',
    sharebot_organization: 'Adicionar novo nome de organização',
    share_sphere: 'Esfera Compartilhada',
    ai_course_title: 'Título do Curso',
    ai_input_course_title: 'Por favor, insira o título do curso!',
    learning_objective_label: 'Objetivo de Aprendizagem',
    learning_objective_message: 'Por favor, insira o objetivo de aprendizagem!',
    standard_question: 'Você tem algum padrão que o aluno precisa seguir?',
    standard_details_label: 'Detalhes do Padrão',
    standard_details_message: 'Por favor, insira os detalhes do padrão!',
    estimated_duration_label: 'Duração Estimada do Curso (em minutos)',
    estimated_duration_message: 'Por favor, insira a duração estimada!',
    min_duration_message: 'A duração mínima é de 5 minutos.',
    ai_mins: '25 min',
    industry_specific_question: 'É específico para alguma indústria?',
    industry_label: 'Especificar Indústria',
    industry_message: 'Por favor, insira a indústria!',
    ai_course_creation: 'Criação de Curso com IA',
    course_generated: 'Curso Gerado pelo Sharelook',
    ai: 'IA',
    ai_you: 'Você',
    ai_prompt_ready:
      'Seu prompt está pronto. Agora você está pronto para gerar o índice.',
    ai_unable_respond:
      'Desculpe! A IA não consegue responder ao seu prompt. Por favor, tente novamente.',
    ai_hide_toc: 'Ocultar Índice',
    ai_preview_toc: 'Visualizar Índice',
    ai_generate_toc_now: 'Gerar Índice Agora',
    ai_creation_course_title: 'Título do Curso:',
    ai_creation_industry_specific: 'É Específico para Indústria:',
    ai_creation_industry: 'Indústria:',
    ai_creation_standard_needed:
      'Você Tem Algum Padrão Que O Aluno Precisa Seguir?:',
    ai_creation_standard_details: 'Detalhes do Padrão:',
    ai_creation_estimated_duration: 'Duração Estimada Do Curso (Em Minutos):',
    minutes: 'minutos',
    ai_creation_learning_objective: 'Objetivo de Aprendizagem:',
    setup_again: 'Configurar Novamente',
    ai_creation_confirm_title:
      'Tem certeza de que deseja configurar o formulário novamente?',
    ai_creation_confirm_content:
      'O chat e todo o conteúdo que você gerou serão redefinidos.',
    ai_toc: 'Índice',
    ai_note_topic:
      'Nota: Você pode arrastar e soltar para reordenar tópicos dentro da lição.',
    ai_add_topic: '+ Adicionar Tópico',
    add_topic: 'Adicionar Tópico',
    add_lesson: 'Adicionar Lição',
    add_new_lesson: 'Adicionar Nova Lição',
    ai_add_lesson: '+ Adicionar Lição',
    attention: 'Atenção',
    before_varifying: 'Antes de Verificar',
    ai_save_later: 'Salvar Para Mais Tarde',
    ai_download_word_doc: 'Baixar como Documento Word',
    ai_download_course_word_doc: 'Baixar Curso como Documento Word',
    ai_create_course_button: 'Criar Curso',
    ai_generate_course_content: 'Gerar Conteúdo do Curso',
    ai_out_of: 'de',
    ai_subtopic_failed_content:
      'subtópicos falharam ao gerar conteúdo. Clique em "Gerar Conteúdo do Curso" novamente para gerar conteúdo apenas para esses subtópicos.',
    ai_edit_topic: 'Editar Tópico',
    ai_edit_lesson_title: 'Editar Título da Lição',
    ai_save_topic: 'Salvar Tópico',
    ai_save: 'Salvar',
    ai_save_lesson_title: 'Salvar Título da Lição',
    ai_add_new_topic: 'Adicionar Novo Tópico',
    ai_download_ref: 'Baixar com Referências',
    ai_download_ref_content:
      'Irá baixar o curso como um documento Word com referências.',
    ai_download_without_ref: 'Baixar sem Referências',
    ai_download_two_word: 'Dois documentos Word serão baixados:',
    ai_download_two_word_content_one:
      '- um contendo o conteúdo principal sem referências,',
    ai_download_two_word_content_two:
      'e outro consistindo apenas de uma lista de referências sem conteúdo adicional.',
    ai_manage_content: 'Gerenciar Conteúdo',
    ai_add_content_from_internet: '+Adicionar Conteúdo da Internet',
    ai_confirm_start: 'Confirmar Início',
    ai_Verify: 'Verificar',
    ai_undo_warning:
      'Este processo pode levar algum tempo. Por favor, não feche esta janela até que a geração seja concluída, pois não pode ser desfeita.',
    ai_verified_content:
      'Você verificou o conteúdo. Note que após a confirmação, você não poderá retornar ao chat com o assistente de IA com o conteúdo atual.',
    ai_want_proceed: 'Tem certeza de que deseja prosseguir?',
    upload_simulation: 'Carregar Simulação',
    name_simulation: 'Nome da Simulação',
    selected_simulation_files: 'Arquivos de Simulação Selecionados',
    score_between_one_hundred: 'Sua pontuação deve estar entre 1 e 100.',
    are_sure_simulation:
      'Tem certeza de que deseja excluir este arquivo de simulação?',
    required_simulation: 'Pontuação é obrigatória',
    required_section_file: 'Arquivo de seção é obrigatório',
    simulation: 'Simulação',
    simulation_quiz_games: 'Precisa adicionar quiz nos jogos',
    simulation_alert_des:
      'Você pode adicionar jogos apenas se todas as questões tiverem tipo de resposta única ou múltipla.',
    alert_info: 'informação',
    ai_number_quiz: 'Número de Quiz',
    ai_point: 'Ponto',
    ai_points: 'Pontos',
    val_required: 'Obrigatório',
    games: 'Jogos',
    add_simulation: 'Adicionar Simulação',
    text_tiewer: 'Visualizador de Texto',
    back_to_account: 'Voltar à Conta',
    delete_account: 'Excluir Conta',
    delete_account_title: 'Excluir Conta ???',
    delete_account_subtitle: 'Você pode excluir sua conta aqui.',
    delete_account_cannot_undo:
      'Você está prestes a excluir sua conta. Esta ação não pode ser desfeita.',
    account_org_profile:
      'Você também perderá todos os cursos que criou, seu perfil organizacional e todas as suas configurações.',
    deleting_account_database:
      'Excluir sua conta removerá todos os seus dados do nosso banco de dados.',
    account_confirm_delete: 'Tem certeza de que deseja excluir sua conta?',
    action_cannot_be_undone: 'Esta ação não pode ser desfeita.',
    account_delete_message_success: 'Sua conta foi excluída com sucesso.',
    message_edit: 'Editar',
    message_delete: 'Excluir',
    message_reply: 'Responder',
    attached_file: 'Arquivo Anexado',
    attach_file: 'Anexar Arquivo',
    attach_des: '25 MB, tamanho máximo do arquivo',
    view: 'Visualizar',
    go_to_marketplace: 'Ir ao Marketplace',
    learning_center: 'Centro de Aprendizagem',
    knowledge_center: 'Centro de Conhecimento',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Como posso ajudá-lo hoje?',
    my_organization: 'Minha Organização',
    world_knowledge: 'Conhecimento Mundial',
    welcome_to_sharelook: 'Bem-vindo ao Sharelook!',
    sharelook_you_want_go: 'Onde você quer ir hoje?',
    shareLook_learning_management_system:
      'Acesse o sistema de gerenciamento de aprendizagem ShareLook para criar ou acessar recursos de aprendizagem como eventos ao vivo e cursos em sua organização no ShareLook.',
    shareLook_powerful_ai_system:
      'Acesse o poderoso sistema alimentado por IA do ShareLook, onde você pode carregar documentos PDF e obter insights úteis ao seu alcance em segundos. Recupere respostas rápidas baseadas nos recursos carregados em sua organização ou obtenha respostas do nosso sistema de IA genérico na seção de conhecimento mundial.',
    edit_now: 'Editar Agora',
    sharelook_log_out:
      'Você foi desconectado do Sharelook. Por favor, faça login!',
    sorry_error: 'Desculpe! Experimentamos algum erro.',
    login: 'Entrar',
    refresh_page: 'Atualizar Página',
    just_a_moment: 'Apenas um Momento',
    enter_lname_fname:
      'Por favor, insira seu nome e sobrenome para prosseguir.',
    procced_to_sharelook: 'Prosseguir para o Sharelook',
    option_one: 'Opção 1',
    option_two: 'Opção 2',
    selected_image: 'Imagem Selecionada:',
    add_text: 'Adicionar Texto',
    linkdin_is_required: 'LinkedIn é obrigatório.',
    bio_is_required: 'Biografia é obrigatória.',
    save_user_information: 'Salvar Informações do Usuário',
    select_all: 'Selecionar Tudo',
    enable_ai: 'Habilitar IA',
    load_more: 'Carregar Mais',
    channel_id: 'ID do Canal.',
    send: 'Enviar',
    v4: 'Informação',
    subscription: 'Assinatura',
    reset_user_flag: 'REDEFINIR FLAG DO USUÁRIO',
    delete_my_accont: 'Excluir minha conta',
    sharebot_sub_error: 'Erro ao buscar assinaturas. Tente novamente!',
    sharebot_no_sub: 'Você atualmente não tem assinaturas ativas.',
    sharebot_dont_sub: 'Você não tem assinaturas anteriores.',
    sharebot_prev_sub: 'Assinado Anteriormente',
    sharebot_sub: 'Assinatura ShareBot',
    sharebot_un_sub: 'Cancelamento ShareBot',
    sharebot_no_available: 'Nenhuma Descrição Disponível',
    sharebot_start_date: 'Data de Início:',
    sharebot_end_date: 'Data de Término:',
    sharebot_sure: 'Tem certeza?',
    sharebot_do_you_want: 'Você quer',
    unsubscribe: 'cancelar assinatura',
    unsubscribe_what: 'cancelar assinatura?',
    subscribe: 'assinar',
    subscribe_what: 'assinar?',
    subscribe_now: 'assinar Agora',
    confirm: 'Confirmar',
    sharebot_intel_knowledge_center:
      'Centro de Conhecimento Inteligente do ShareBot',
    sharebot_welcome_paragraph:
      'Bem-vindo ao Centro de Conhecimento do ShareBot, o chatbot de IA avançado projetado para transformar como os profissionais acessam informações e colaboram.',
    expired: 'Expirado',
    active: 'Ativo',
    Inactive: 'Inativo',
    yearly_subscription: 'Assinatura Anual',
    monthly_subscription: 'Assinatura Mensal',
    no_sharebot_org: 'Você não tem organização sharebot',
    sharebot_start_free_trial: 'Iniciar Teste Gratuito',
    sub_month: 'Assinatura Mensal',
    sub_year: 'Assinatura Anual',
    question_per_month: 'Armazenamento de Dados (1TB) e 1000 Perguntas por Mês',
    sharebot_para:
      'Ao prosseguir, você está confirmando a exclusão imediata da organização. Esta ação resultará na perda de todos os insights valiosos fornecidos pelo ShareBot, e não pode ser desfeita.',
    cancelled_date: 'Data de Cancelamento:',
    live_straming_para:
      'Se você deseja alterar seu limite mensal de transmissão ao vivo, entre em contato',
    sharelook_agree: 'Concordo com os',
    terms_condition: 'termos e condições',
    and: 'e',
    privacy_policy: 'política de privacidade',
    save_for_later: 'Salvar Para Mais Tarde',
    ai: 'IA',
    no_video_yet: 'Nenhum Vídeo Selecionado Ainda!',
    are_you_sure_delete_video: 'Tem certeza de que deseja excluir este vídeo?',
    video_des: 'Descrição',
    video_now: 'Agora',
    video_playing: 'Reproduzindo:',
    video_no: 'Vídeo Nº',
    ai_generated_course: 'Curso Gerado por IA',
    create_course_on_our_own: 'Criar um Curso por Conta Própria',
    ai_Assisted_ourse_reation: 'Criação de Curso Assistida por IA',
    pending: 'Pendente',
    published: 'Publicado',
    intro_course: 'no seu curso?',
    clone_course: 'Gostaria de clonar',
    browser_audio_not_support: 'Seu navegador não suporta a tag de áudio.',
    audio_popup_content:
      'Onde você pode usar muitos estilos de voz sobre o texto que você digita bla bla bla Lorem Ipsum é simplesmente texto fictício da indústria de impressão e composição. Lorem Ipsum tem sido o texto fictício padrão da indústria desde os anos 1500,',
    close: 'Fechar',
    podcast_rec: 'REC',
    create_podcast: 'Criar Podcast',
    add_admin: 'ADICIONAR ADMIN',
    delete_all: 'Excluir tudo',
    ai_podcast_audio: 'Áudio de Podcast IA',
    language: 'Idioma',
    podcast_download_content:
      '*Baixe o arquivo de áudio IA para edição e torne-o seu arquivo de áudio.',
    upload_audio: 'Carregar Áudio',
    browser_do_not_support_audio:
      'Seu navegador não suporta o elemento de áudio.',
    upload_cover: 'Carregar Capa',
    upload_ai_creator: 'Criador IA',
    required_cover_image: 'Imagem de capa é obrigatória!',
    room_required_name: 'Nome do Podcast é obrigatório!',
    add_guest_list: 'Por favor, adicione listas de convidados!',
    podcast_add_participants: 'ADICIONAR PARTICIPANTE',
    topic_required: 'Pelo menos um tópico é obrigatório',
    podcast_description: 'DESCRIÇÃO',
    podcast_date: 'DATA',
    date: 'Data',
    podcast_time: 'hora',
    podcast_to: 'até',
    podcast_all_day: 'Dia todo',
    podcast_start_date_time:
      'Data de Início e Intervalo de Tempo São Obrigatórios!',
    podcast_id: 'ID',
    selected_user: 'Convidar Usuários Selecionados',
    see_more: 'Ver Mais',
    see_less: 'Ver Menos',
    no_review_yet: 'Nenhuma avaliação ainda, seja o primeiro a avaliar.',
    request_to_speak: 'Aceitar solicitação do usuário para falar?',
    kick_user: 'Você quer expulsar este usuário?',
    accept_request: 'Aceitar Solicitação',
    kick: 'EXPULSAR',
    started: 'INICIADO',
    end: 'FIM',
    join_now: 'Participar Agora',
    podcast_end: 'Podcast terminou',
    connecting: 'conectando...',
    knowledge_center_know_today: 'O que você gostaria de saber hoje?',
    knowledge_center_question: 'Por favor, digite uma pergunta primeiro',
    knowledge_center_error: 'Desculpe! Experimentamos algum erro.',
    knowledge_center_tooltrip:
      'Obtenha respostas rápidas dos recursos de aprendizagem no repositório da sua organização no ShareLook, com referências adequadas e possibilidade de visualizar e baixar os documentos PDF referenciados.',
    my_organization: 'Minha Organização',
    world_knowledge: 'Conhecimento Mundial',
    open_file: 'Abrir Arquivo',
    reference: 'Referência',
    are_you_cancel: 'Tem certeza de que deseja cancelar?',
    are_you_remove_media: 'Tem certeza de que deseja remover a mídia?',
    terms_agree: 'Concordo com estes',
    ready: 'Pronto',
    send_email: 'ENVIAR EMAIL',
    active_users: 'Usuários ativos',
    sign_up_user: 'Usuários cadastrados',
    non_sign_up_user: 'Usuários não cadastrados',
    organisation: 'Organização',
    usage_report: 'Relatório de Uso',
    check_email: 'verifique seu email',
    delete_schedule: 'Excluir Agenda',
    are_you_sure_delete_schedule:
      'Tem certeza de que deseja excluir esta agenda?',
    add_task: 'Por favor, insira uma tarefa!',
    coaching_available: 'Marcar como Disponibilidade de Coaching',
    message_booking_coaching:
      'Este horário foi reservado por um usuário para coaching.',
    task_day: 'Dia da Tarefa',
    created_task_day: 'Você criou uma tarefa para este dia.',
    event_day: 'Dia do Evento',
    has_booked_coaching: 'Um coaching foi reservado para este dia.',
    active_day: 'Dia Ativo',
    selectable_time_slots:
      'Os horários selecionáveis à direita estão ativos para este dia.',
    compare_last_month: 'Comparado ao mês passado',
    uploading_file: 'Carregando seu arquivo',
    attach_file_course: 'anexado a este curso.',
    fetch_request: 'Buscando sua solicitação',
    finilize_upload: 'Finalizando upload',
    scorm_scanned:
      'Por favor, aguarde... Seu zip SCORM carregado está sendo escaneado.',
    scan_status: 'Status do Scan:',
    scan_completed: 'Scan concluído. Seu arquivo está',
    scan_progress: 'Scan em andamento...',
    check_scorm:
      'Verificando o formato do arquivo SCORM... Por favor, aguarde...',
    file_check_success: 'Verificação do arquivo bem-sucedida',
    file_check_progress: 'Verificação do arquivo em andamento...',
    scorm_not_upload:
      'Seu arquivo carregado não é padrão SCORM 1.2, por favor carregue o arquivo novamente.',
    select_question: 'Opções de Resposta (selecione uma resposta correta)',
    select_answer: 'Por favor, selecione a opção de resposta!',
    check_option_one: 'Por favor, insira a opção um!',
    check_option_two: 'Por favor, insira a opção dois!',
    check_option_three: 'Por favor, insira a opção três!',
    check_option_four: 'Por favor, insira a opção quatro!',
    question_image: 'Imagem da Pergunta',
    select_question_image: 'Por favor, selecione a imagem da pergunta!',
    ans_image: 'Imagem da Resposta',
    upload_image_question: 'Carregar Imagem da Resposta',
    select_image_answer: 'Por favor, selecione a imagem da resposta!',
    save_question: 'Salvar Pergunta',
    do_you_leave: 'Tem certeza de que deseja sair?',
    loose_all_progress: 'Você perderá todo o seu progresso.',
    welcome: 'Bem-vindo',
    team_knowledge_quest: 'Busca de Conhecimento da Equipe',
    your_score: 'Sua Pontuação',
    start_playing: 'Começar a Jogar',
    share_sphere_complete: 'ShareSphere Completo',
    final_score: 'Pontuação Final',
    play_next: 'Jogar Próximo',
    you_donot_access_event: 'Você não tem acesso a este evento.',
    ai_content_generated: 'O conteúdo foi gerado para este tópico.',
    ai_popup_confirm_content: 'Confirmar Geração de Conteúdo',
    limit_transcribe_text:
      'Minutos Restantes para Transcrição: <0>{{ transcribe_limit }}</0> minutos <1/><2/> <3>. Para alterar seu limite de transcrição, entre em contato com </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Você não tem acesso a este evento.',
    ai_course_title_training: 'Cursos de treinamento em liderança',
    ai_course_object: 'Navegando pela Liderança na Era Digital',
    create_ai_video: 'Criar Vídeo com IA',
    generate: 'GERAR',
    video_generate_process:
      'O processo de geração do vídeo pode levar algum tempo. Você receberá um e-mail quando estiver concluído.',
    stripe_account_connect:
      'Sua conta Stripe está inativa. Conecte ou ative-a para continuar.',
    ai_creator: 'Criador de IA',
    check_video_status: 'Verificando o status da geração do vídeo...',
    video_on_queue: 'A geração do vídeo está na fila.',
    video_fail_generation:
      'Desculpe, a geração do vídeo falhou. Por favor, tente outro.',
    video_currently_generated: 'Este vídeo está sendo gerado no momento.',
    checking_status: 'Verificando status',
    check_status: 'Verificar status',
    browser_does_not_support_audio: 'Seu navegador não suporta a tag de áudio',
    existing_edit_scenario:
      'Deseja editar o cenário existente ou criar um novo? Se você criar um novo, o antigo será perdido.',
    generate_scenario: 'Gerar Cenário',
    layout: 'Layout',
    confirm_change: 'Confirmar Alteração',
    generated_ai_creation_message:
      'Atenção: apenas os elementos de texto gerados pela IA serão mantidos. Todos os outros elementos serão removidos da página.',
    generate_story: 'Gerar História',
    save_original_content: 'Salvar conteúdo original:',
    story_added_specified_position:
      'A posição da história na lição. Ela será adicionada como um bloco na posição especificada.',
    position_of_story: 'Posição da História',
    start_the_lesson: 'Início da Lição',
    end_the_lesson: 'Fim da Lição',
    add_story_pages: 'Adicionar História às Páginas',
    browser_does_not_support: 'Seu navegador não suporta o elemento de áudio.',
    no_video_available: 'Nenhum vídeo disponível.',
    no_podcast_available: 'Nenhum podcast disponível.',
    no_item_baskets: 'Nenhum item no carrinho.',
    ai_course_object: 'Navegando pela Liderança na Era Digital'
  },
  v2: {
    n_data: 'Sem dados',
    change: 'Alterar',
    remove: 'Remover',
    auto_background: 'Fundo automático',
    create_new_course_org: 'Crie um novo curso para sua organização.',
    create_new_course_marketplace: 'Crie um novo curso para o marketplace.',
    create_new_course_both:
      'Crie um novo curso para sua organização e para o marketplace.',
    ok: 'Ok',
    page_bg: 'Fundo da página',
    lesson_cover: 'Imagem de capa da aula',
    create_skill_journey: 'Criar uma Jornada de Habilidades',
    Metamaze: 'Metamaze',
    events: 'Eventos',
    scroms: 'SCORMs',
    min_score_pass: 'Pontuação mínima para aprovação',
    no_scorms_available: 'Nenhum SCORM disponível.',
    no_events_available: 'Nenhum evento disponível.',
    no_courses_available: 'Nenhum curso disponível.',
    no_courses_baskets: 'Nenhum curso no carrinho.',
    no_mazes_baskets: 'Nenhum labirinto no carrinho.',
    no_scroms_baskets: 'Nenhum SCORM no carrinho.',
    no_events_baskets: 'Nenhum evento no carrinho.',
    sorry: 'Desculpe!',
    option_1: 'Opção 1',
    option_2: 'Opção 2',
    enter_number_words: 'Digite o número máximo de palavras.',
    summarize: 'Resumir',
    answer: 'Resposta',
    hold_tight_one_minute:
      'Aguarde! Ainda estamos preparando. Isso pode levar até um minuto.',
    enter_question: 'Digite sua pergunta.',
    enter_relevant_documents: 'Insira o número de documentos relevantes.',
    please_input_relevant_documents:
      'Por favor, insira o número de documentos relevantes!',
    please_wait_loading_results: 'Aguarde o carregamento dos resultados...',
    proceed_to_add_voice: 'Prossiga para adicionar voz',
    results: 'Resultados',
    no_result_found_try_asking_questions:
      'Nenhum resultado encontrado. Tente fazer mais perguntas.',
    eg: 'ex:',
    what_make_sales_manager: 'O que pode me tornar um gerente de vendas?',
    please_select_lang: 'Por favor, selecione um idioma!',
    search: 'Pesquisar',
    please_copy_desired_content:
      'Copie o conteúdo desejado da caixa à esquerda para a caixa à direita.',
    rating_req: 'Avaliação é um campo obrigatório.',
    review_req: 'Comentário é um campo obrigatório.',
    rating_review_req: 'É necessário fornecer uma avaliação e um comentário.',
    how_rate_this: 'Como você avaliaria isso?',
    amazing_above_expectations: 'Incrível! Acima das expectativas!',
    certificates: 'Certificados',
    you_no_certificates: 'Você não possui certificados disponíveis no momento.',
    please_add_review:
      'Por favor, forneça um comentário junto com a avaliação. Obrigado!',
    post: 'Publicar',
    rate: 'Avaliar',
    avg_rating: 'Avaliação média',
    no_review_found: 'Nenhum comentário encontrado',
    are_sure_to_disale_zoom_integration:
      'Tem certeza de que deseja desativar a integração com o Zoom?',
    badges: 'Distintivos',
    you_no_badge_available:
      'Você não possui distintivos disponíveis no momento.',
    download_certificate: 'Baixar certificado',
    loading: 'Carregando...',
    no_file_attached: 'Nenhum arquivo anexado',
    you_do_not_have_any_notes: 'Você não tem nenhuma anotação.',
    question: 'Pergunta',
    score: 'Pontuação',
    alert_score_message: 'Pessoa(s) enviaram suas pontuações.',
    alert_question_message: 'Nenhuma pergunta foi adicionada até agora.',
    button_submit: 'Enviar',
    button_allScores: 'Todas as pontuações foram enviadas.',
    record_wait: 'Gravação iniciando. Por favor, aguarde...',
    buttonSubmit_warning:
      'Por favor, insira todas as pontuações antes de enviar.',
    upload_ar_assets: 'Carregar Recursos AR',
    edit_ar_assets: 'Editar Recursos AR',
    edit_maze_assets: 'Editar Recursos MetaMaze',
    upload_assets: 'Carregar Recursos',
    upload_maze_assets: 'Carregar Recursos MetaMaze',
    trigger_title: 'Título do Disparador',
    model_title: 'Título do Modelo',
    trigger_description: 'Descrição do Disparador',
    model_description: 'Descrição do Modelo',
    please_type_target_description: 'Por favor, digite a descrição alvo.',
    please_type_model_description: 'Por favor, digite a descrição do modelo.',
    trigger_image: 'Imagem do Disparador*',
    model_image: 'Imagem do Modelo*',
    upload_trigger_image: 'Carregar Imagem do Disparador',
    upload_model_image: 'Carregar Imagem do Modelo',
    drag_n_drop: 'Arrastar e Soltar',
    file_size_should_not_exceed:
      '(O tamanho do arquivo de imagem (JPEG) não deve exceder 512 KB)',
    zip_size_should_not_exceed:
      '(O tamanho do arquivo ZIP não deve exceder 60 MB)',
    ar_content: 'Conteúdo AR*',
    model_content: 'Modelo 3D*',
    upload_3d_zip: 'Carregar ZIP / Vídeo',
    upload_3d_maze_zip: 'Carregar ZIP',
    audio_content: 'Conteúdo de Áudio',
    _mp3: '(.mp3)',
    content_attached: 'ZIP Anexado.',
    video_attached: 'Vídeo Anexado.',
    audio_attached: 'Áudio Anexado.',
    enter_trigger_image_title: 'Digite o título da imagem do disparador.',
    enter_model_title: 'Digite o título do modelo MetaMaze.',
    ar_preview_image: 'Imagem de Pré-visualização AR',
    upload_preview_image: 'Carregar Imagem de Pré-visualização',
    upload_audio: 'Carregar Áudio',
    creating___: 'Criando...',
    updating___: 'Atualizando...',
    create: 'Criar',
    update: 'Atualizar',
    ar_assets: 'Imagem 3D',
    _3d_files_mp4: '(Arquivos .obj, .fbx ou vídeo .mp4 compactados)',
    _3d_files_mp4_ar: '(Arquivos .obj, .fbx compactados)',
    maze_3d_files_mp4: '(Arquivos .obj, .fbx compactados)',
    _jpg_files: 'Suporta apenas .jpg',
    persons_have_submitted_their_scores: 'Pessoa(s) enviaram suas pontuações.',
    no_questions_added_till_now: 'Nenhuma pergunta adicionada até agora.',
    submit: 'Enviar',
    all_scores_submitted: 'Todas as pontuações foram enviadas.',
    recording_is_starting: 'A gravação está começando. Por favor, aguarde...',
    please_input_scores_before_submitting:
      'Por favor, insira todas as pontuações antes de enviar.',
    end_for_all: 'Encerrar para Todos',
    full_screen: 'Tela Cheia',
    breakout_room: 'Sala de Grupo',
    send_invitations: 'Enviar Convite(s)',
    add_participants: 'Adicionar Participante(s)',
    create_breakout_room: 'Criar Sala de Grupo',
    connecting: 'Conectando...',
    currently_broadcaster_unavailable:
      'Atualmente, o transmissor está indisponível.',
    how_many_breakout_room_to_create:
      'Quantas salas de grupo você deseja criar?',
    create_upto_three_breakout_rooms: '*Criar até 3 Salas de Grupo',
    allow: 'Permitir',
    additional: 'Adicional',
    attachment: 'Anexos',
    no_description_available: 'Nenhuma descrição disponível.',
    people: 'PESSOAS',
    waiting: 'Aguardando',
    hand_raising_users: 'Usuários levantando a mão',
    invite: 'Convidar',
    create_room: 'Criar Sala',
    create_live_event: 'Criar Evento ao Vivo',
    support_upto_fivethousand_participants:
      'Suporta até 5.000 participantes para o evento',
    support_upto_ten_participants:
      'Suporta até 10 participantes de vídeo ao vivo',
    support_upto_twohundred_participants:
      'Suporta até 200 participantes para o evento',
    supprt_upto_five_participants:
      'Suporta até 5 participantes de vídeo ao vivo',
    support_upto_twentyfive_participants:
      'Suporta até 25 participantes de vídeo ao vivo para o evento',
    two_live_video_participants:
      'Existem 2 participantes de vídeo ao vivo para o evento (host e participante)',
    you_can_have_upto_five_examinees: 'Você pode ter no máximo 5 examinados.',
    you_can_have_upto_twentyfive_participants:
      'Você pode ter no máximo 25 participantes.',
    you_can_have_upto_five_participants:
      'Você pode ter no máximo 5 participantes.',
    you_can_have_upto_ten_participants:
      'Você pode ter no máximo 10 participantes.',
    select_hosts_email: 'Selecione o E-mail do Host',
    send_invite_email: 'Enviar E-mail de Convite',
    do_not_send_invite_email: 'Não enviar E-mail de Convite',
    error: 'Erro',
    max_twentyfive_users_allowed:
      'Máximo de 25 usuários permitidos para seleção',
    max_five_users_allowed: 'Máximo de 5 usuários permitidos para seleção',
    max_ten_users_allowed: 'Máximo de 10 usuários permitidos para seleção',
    no_user_found: 'Nenhum usuário encontrado',
    transcribe_to: 'Transcrever para',
    integrate_zoom_to_start_meeting:
      'Integre o Zoom na sua conta para iniciar uma reunião Zoom.',
    zoom_is_not_integrated: 'Zoom não está integrado.',
    delete_poll: 'Excluir Enquete',
    add_poll: 'Adicionar Enquete',
    live_now: 'AO VIVO AGORA!',
    average_rating: 'Avaliação Média',
    review: 'Avaliação',
    time_spent: 'Tempo Gasto',
    total: 'Total',
    mins: 'Minutos',
    no_data: 'Não há dados para este quiz.',
    total_score: 'Pontuação Total',
    pass_score: 'Pontuação de Aprovação',
    point: 'Ponto',
    wrong: 'Errado',
    response: 'Resposta',
    submitted: 'Enviado',
    average: 'Média',
    total_play: 'Total de Jogadas',
    view_graph: 'Ver Gráfico',
    time_spent_mins: 'Tempo Gasto (Minutos)',
    play: 'Jogar',
    ideal_path: 'Caminho Ideal',
    user_incorrect_path: 'Caminho Incorreto do Usuário',
    ideal_path_taken: 'Caminho Ideal Seguido pelo Usuário',
    scenario: 'Cenário',
    option: 'Opção',
    spend: 'Gasto',
    average_spending_time: 'Tempo Médio Gasto',
    activity_overview: 'Visão Geral da Atividade',
    live_event: 'Evento Ao Vivo',
    live_assessment: 'Avaliação Ao Vivo',
    report_download: 'Download do Relatório',
    all_workshops: 'Todos os Workshops',
    overview_average_activity: 'Visão Geral da Atividade Média',
    overview_workshop_graph: 'Gráfico de Visão Geral do Workshop',
    mazes: 'Labirintos',
    correct_feedback: 'Feedback Correto',
    incorrect_feedback: 'Feedback Incorreto',
    checkin_checkout: 'Check-In - Check-Out',
    minutes: 'Minutos',
    incorrect_path: 'Caminho Incorreto',
    answer_not_available: 'Resposta Não Disponível',
    views: 'Visualizações',
    item: 'Item',
    questions: 'Perguntas',
    total_points: 'Pontos Totais',
    total_attempts: 'Tentativas Totais',
    created_date: 'Data de Criação',
    host_name: 'Nome do Anfitrião',
    host_section: 'Seção do Anfitrião',
    choose_products: 'Escolher Produtos',
    add_to_basket: 'Adicionar ao Carrinho',
    basket: 'Carrinho',
    times: 'Vezes',
    scorms: 'SCORMs',
    skill_journey_overview: 'Visão Geral da Jornada de Habilidades',
    how_to_use: 'Como Usar',
    live_broadcast_description:
      'INTEGRAMOS VÍDEO AO VIVO EM UM CONSTRUTOR DE CURSOS FÁCIL DE USAR',
    live_broadcast_subdescription:
      'Com o sistema patenteado de transmissão ao vivo da ShareLook, você pode criar engajamento, automatizar o aprendizado e maximizar o compartilhamento de conhecimento.',
    disclaimer: `Eu garanto que minha jornada de habilidades não irá: 
  - infringir os direitos de terceiros
  - conter qualquer ilegalidade, incluindo difamação, obscenidade, indecência, lascívia, pornografia, violência, abuso, insulto, ameaça ou conteúdo discriminatório, mesmo disfarçado com asteriscos
  - conter ataques pessoais a outras pessoas
  - conter personificação de outros participantes, figuras públicas ou celebridades
  - conter qualquer gravação ou informação pessoal de qualquer indivíduo sem o consentimento desse indivíduo e não infringir qualquer regulamento de proteção de dados em qualquer parte do mundo
  - conter qualquer solicitação comercial ou qualquer forma de “spam”`,
    price: 'Preço',
    video_link: 'Link do Vídeo',
    category: 'Categoria',
    objectives: 'Objetivos',
    marketplace_description: 'Descrição do Marketplace',

    live_discussion: 'DISCUSSÃO AO VIVO',
    poll: 'ENQUETE',
    hide_grid: 'Ocultar Grade',
    show_grid: 'Mostrar Grade',
    stop_screen_share: 'Parar Compartilhamento de Tela',
    screen_share: 'Compartilhar Tela',
    mute: 'Silenciar',
    unmute: 'Ativar Som',
    raise_hand: 'Levantar a Mão',
    waiting__: 'Aguardando...',
    audio_active: 'Áudio Ativo'
  },
  general: {
    save: 'Salve',
    autosaved: 'salvo automaticamente',
    back_to: 'de volta a',
    by: 'De',
    chat: 'Bate-papo',
    completed: 'Concluída',
    canceled: 'Cancelado',
    component: 'Componente',
    confirme: 'Confirme',
    course: 'Curso',
    skill: 'Jornada de Habilidades',
    maze: 'MetaLabirinto',
    channel: 'Canal',
    podcast: 'Podcast',

    date: 'Data',
    details: 'Detalhes',
    empty: 'Sem dados',
    enrolled: 'Inscrito',
    free: 'Livre',
    graph: 'Gráfico',
    loading: 'Carregando...',
    lesson: 'lição',
    lessons: 'aulas',
    live_assessment: 'Avaliação ao vivo',
    live_event: 'Evento ao vivo',
    no: 'Não',
    of: 'De',
    or: 'Ou',
    organization: 'Organização',
    page: 'Página',
    pages: 'Páginas',
    personal: 'Pessoal',
    poll: 'Votação',
    rating: 'Classificação',
    reset: 'Redefinir',
    signin: 'Assinar em',
    signup: 'Inscrever-se',
    soon: 'Em breve',
    type: 'Tipo',
    uploading: 'Enviando...',
    yes: 'Sim',
    something_went_wrong: 'Algo deu errado!',
    view_all: 'Ver tudo',
    upload_successful: 'Upload bem sucedido',
    upload_successful_message:
      'Seus documentos Excel foram enviados com sucesso e estão sendo processados no momento. Isto pode levar algum tempo.',
    check_email_upload_successful:
      'Por favor, <0>verifique seu e-mail</0>para o<1>relatório</1>da lista de usuários carregada.',
    is_private: 'Privado'
  },

  account: {
    title: 'Conta',
    subtitle: 'Gerenciar suas configurações e informações da conta.',
    saved: 'Conta alterada com sucesso'
  },

  assessments: {
    title: 'Assessments',
    subtitle: 'Criar uma avaliação',
    finished: 'A avaliação está concluída',
    countdown: 'Avaliação ao vivo será transmitida em',
    create: 'Criar Avaliação',
    list_title: 'Suas avaliações',
    delete_warning: 'Tem certeza de que deseja excluir este item?',
    details_title: 'Adicionar Detalhes de Avaliação',
    details_subtitle:
      'Dê um nome à sua avaliação e diga ao seu público o que eles devem esperar aprender com ela.',
    disclaimer: `Eu garanto que minha avaliação gravada não irá:
  - infringir os direitos de terceiros
- conter qualquer ilegalidade, incluindo conteúdo difamatório, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultuoso, ameaçador ou discriminatório, mesmo disfarçado com asteriscos
- conter quaisquer ataques pessoais a outras pessoas
- conter qualquer falsificação de identidade de outros participantes, figuras públicas ou celebridades
- contém qualquer gravação ou informação pessoal sobre qualquer indivíduo sem o consentimento de tal indivíduo e não viola qualquer regulamento de proteção de dados em qualquer parte do mundo
- conter qualquer solicitação comercial ou qualquer forma de “spam” `
  },

  buildersettings: {
    title: 'Configurações de publicação',
    subtitle:
      'Adicionar configurações ao seu evento, quem pode ver e interagir com ele'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Adicionar',
    add_page: 'Adicionar Página',
    add_lesson: 'Adicionar aulas',
    add_answer: 'Adicionar nova resposta',
    add_group: 'Adicionar grupo',
    add_organization: 'Adicionar Organização',
    add_question: 'Adicionar pergunta',
    add_quiz: 'Adicionar questionário',
    add_users: 'Adicionar usuários',
    back: 'Voltar',
    back_to_course: 'Voltar à Visão Geral do Curso',
    back_to_lesson: 'Voltar à visão geral da lição',
    back_to_media: 'Voltar à biblioteca de mídia',
    back_to_details: 'Voltar aos detalhes',
    cancel: 'Cancelar',
    clear: 'Limpar',
    close: 'Perto',
    clone: 'Clone',
    close_lesson: 'Fechar lição',
    clone_course: 'Curso Clone',
    confirm: 'Confirme',
    create: 'Crio',
    download: 'Baixar',
    download_mass_user_tamplate: 'Baixar template',
    add_mass_users: 'Adicionar usuários em massa',
    upload_excel_list: 'Carregar Lista Excel',
    delete: 'Excluir mídia',
    edit: 'Editar',
    edit_course: 'Editar Curso',
    enroll: 'Inscreva-se',
    finish: 'Terminar',
    upload_image: 'Enviar Imagem',
    upload_image_video: 'Carregar imagem ou vídeo',
    select_media_library: 'Selecionar biblioteca de mídia',
    make_public: 'Tornar público',
    make_private: 'Tornar privado',
    make_org: 'Tornar organização',
    media: 'Biblioteca de mídia',
    my_theme: 'Meu tema',
    next: 'Próximo',
    next_lesson: 'Próxima lição',
    next_step: 'Próxima Etapa',
    previous_step: 'Passo anterior',
    publish: 'Publicar',
    publish_assessment: 'Publicar a sua avaliação',
    publish_course: 'Publicar o seu curso',
    publish_event: 'Publicar o seu evento',
    reset: 'Redefinir',
    reset_elements: 'Reiniciar elementos',
    save: 'Salvar',
    creating: 'Criando...',
    updating: 'Atualizando...',
    saved: 'Salvar',
    save_for_later: 'Guardar para depois',
    save_settings: 'Salvar configurações',
    select_files: 'Selecionar arquivos',
    select_theme: 'Selecionar tema',
    start_lesson: 'Iniciar Aula',
    update: 'Atualizar',
    upload: 'Envio',
    upload_audio: 'Carregar Áudio',
    upload_photo: 'Carregar uma foto de perfil',
    upload_video: 'Envio vídeo',
    enrolled: 'Inscrito',
    unenroll: 'Desinscrever',
    from_library: 'Biblioteca de mídia',
    remove: 'Remover',
    removed: 'Removido',
    start_broadcast: 'Iniciar transmissão',
    end_broadcast: 'Finalizar transmissão',
    camera: 'Câmera',
    screen: 'Tela',
    screen_with_camera: 'Tela com Câmera'
  },

  card: {
    quick_add: 'Quick add',
    add: 'Adicionar',
    clone: 'Clone',
    completed: 'lições concluídas'
  },

  course: {
    upcoming_course: 'Próximo Curso',
    unPublishEvent: 'Cancelar Publicação de Evento',
    unPublishAssessment: 'Cancelar publicação de avaliação',
    pastCourse: 'Curso de treinamento',
    upcoming: 'Próximo evento ao vivo',
    pastEvent: 'Evento passado ao vivo',
    pastAssessment: 'Avaliação ao vivo passada',
    upcomingAssessment: 'Próxima avaliação ao vivo',
    created: 'Data Criada:',
    assignees: 'Assignees',
    organisations:
      ' {{ organizations }} Organizações, <2> {{ users }} usuários </2> ',
    event_date: 'Data do evento ao vivo <1> {{ date }} </1> ',
    delete_warning: 'Tem certeza que deseja deletar isto',
    clonning_no_lesson:
      'Por favor, adicione pelo menos uma lição para clonar este curso.',
    clone_warning: 'Tem certeza que deseja clonar isto',
    clone_success: 'está em processo de clonagem',
    disclaimer: `Eu garanto que meu curso não: 
- infringe os direitos de terceiros
- contém qualquer ilegalidade, incluindo conteúdo difamatório, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultuoso, ameaçador ou discriminatório, mesmo disfarçado com asteriscos
- contém quaisquer ataques pessoais a outras pessoas
- contém qualquer falsificação de identidade de outros participantes, figuras públicas ou celebridades
- contém qualquer informação pessoal sobre qualquer indivíduo sem o consentimento de tal indivíduo e não viola qualquer regulamento de proteção de dados em qualquer parte do mundo
- contém qualquer solicitação comercial ou qualquer forma de “spam” `
  },

  coursecreate: {
    dropzone_text: 'Inserir mídia',
    sidebar_text: 'Selecione um tema <1/> para suas <3/> aulas',
    delete_warning: 'Tem certeza de que deseja excluir esta lição?'
  },

  coursepage: {
    quizview_loading: '- Verificando as respostas. Por favor aguarde...',
    quizview_answer: 'Sua resposta'
  },

  Coursequiz: {
    title: 'Testes em todas as aulas'
  },

  coursequiz: {
    tooltip_title: 'Não mostrar este vídeo novamente',
    page_title: `Estatística de 'Seus Cursos`,
    page_subtitle: 'Status dos cursos que você criou',
    profile_add_info:
      'Adicione o seu <1> {{uncompletedText}} </1> para completar o seu perfil. ',
    profile_build:
      'Construa seu perfil <1> aqui </1>, conte-nos seus interesses e habilidades.',
    profile_title: 'Força do perfil',
    more_details: 'Mais detalhes'
  },

  errors: {
    answer: 'Por favor, insira a resposta',
    answer_correct: 'Escolha a resposta correta',
    code: 'Por favor, insira seu código',
    criterion: 'Por favor, insira o critério',
    duration: 'A duração é necessária',
    element: 'Insira o elemento',
    email: 'Por favor, insira seu e-mail',
    email_invalid: 'A entrada não é um e-mail válido',
    feedback_correct: 'Por favor, insira o feedback correto',
    feedback_incorrect: 'Por favor, insira feedback incorreto',
    host: 'Insira o host do evento',
    host_assessment: 'Por favor, insira o host de avaliação',
    image: 'Envie uma imagem',
    location: 'Por favor, insira sua localização',
    live_location: 'Escolha um local de transmissão',
    limit: 'Por favor, insira minutos de transmissão ao vivo',
    min_3char: 'Mínimo de 3 caracteres',
    number: 'insira um número positivo.',
    host_email_require: 'Os e-mails do host são necessários.',
    attendee_email_require: `Os e-mails dos participantes são obrigatórios.`,
    name: 'Por favor, insira seu nome',
    not_found_course: 'Curso não encontrado',
    not_found_event: 'Evento não encontrado',
    not_found_assessment: 'Avaliação não encontrada',
    password: 'Por favor, insira sua senha',
    password_digit: 'Pelo menos um dígito',
    password_short: 'A senha é muito curta, mínimo de 10 caracteres',
    password_special: 'Pelo menos um caractere especial',
    password_uppercase: 'Pelo menos um caractere maiúsculo',
    password_lowercase: 'Pelo menos um caractere minúsculo',
    phone: 'Por favor, insira seu telefone',
    phone_invalid: 'Número de telefone inválido',
    position: 'Por favor, informe sua posição',
    question: 'Por favor, insira a pergunta',
    start_date: 'Data e hora de início são obrigatórias',
    tag: 'Selecione uma tag',
    topics: 'Selecione pelo menos um tópico.',
    live_topics: 'Por favor, adicione tópicos',
    title: 'Por favor, insira o título',
    title_assessment: 'Por favor, insira o título da avaliação',
    title_course: 'Por favor, insira o título do curso',
    title_empty: 'Título não pode estar vazio',
    title_event: 'Insira o título do evento',
    title_lesson: 'Por favor, insira o título da lição',
    title_quiz: 'Por favor, insira o nome do questionário',
    username: 'Por favor, insira seu nome de usuário',
    invalid_verification_code: 'Este link de verificação expirou ou já não é válido. Isto acontece normalmente se foi solicitado um e-mail de verificação mais recente. Por favor, verifique o e-mail mais recente da Sharelook para confirmar o seu e-mail.',
    upload_error: 'Erro - Arquivo não compatível!',
    upload_more_than_10:
      'Você só pode enviar no máximo 10 arquivos de uma vez.',
    topics_max: 'Por favor, adicione 3 tópicos no máximo.',
    upload_excel:
      'Por favor, certifique-se de ter carregado o arquivo correto.',
    title_excel: 'Erro ao enviar modelo:',
    file_size_exceed: 'Tamanho do arquivo excedido',
    subtitle_excel:
      'Certifique-se de usar o modelo fornecido e as colunas preenchidas corretamente.',
    select_broadcast_option: 'Selecione uma opção para transmitir este evento',
    multi_hosts_number_error:
      'Não. do apresentador não pode exceder o especificado para o evento. ',
    conference_people_number_error: `Não. de participantes não pode exceder o especificado para o evento.`,
    select_max_host: 'Selecione pelo menos 1 apresentador para o evento.',
    select_max_conference: 'Selecione pelo menos 1 participante para o evento.',
    stream_stop_error: 'Streaming interrompido inesperadamente!',
    unsecure_context:
      'Erro fatal: o navegador não pode acessar a câmera e o microfone devido a um contexto inseguro. Instale SSL e acesse via https ',
    ws_not_supported:
      'Erro fatal: WebSocket não é compatível com este navegador'
  },

  events: {
    title: 'Adicionar detalhes do evento ao vivo',
    change_host: 'Alterar Host',
    finished: 'O evento terminou',
    countdown: 'O evento ao vivo será transmitido em',
    subtitle:
      'Dê um nome ao seu evento ao vivo e diga ao seu público o que eles devem esperar aprender com ele.',
    poll_disabled: 'Enquete não disponível neste evento',
    disclaimer: `Eu garanto que meu evento gravado não irá: 
- infringir os direitos de terceiros
- conter qualquer ilegalidade, incluindo conteúdo difamatório, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultuoso, ameaçador ou discriminatório, mesmo disfarçado com asteriscos
- conter quaisquer ataques pessoais a outras pessoas
- conter qualquer falsificação de identidade de outros participantes, figuras públicas ou celebridades
- conter qualquer gravação ou informação pessoal sobre qualquer indivíduo sem o consentimento de tal indivíduo e não viola qualquer regulamento de proteção de dados em qualquer parte do mundo
 - conter qualquer solicitação comercial ou qualquer forma de “spam” '`,
    prompt_message:
      'Sair desta página encerrará seu evento. Tem certeza que deseja sair desta página? ',
    duration_exceed_message:
      'Seu tempo de transmissão excede, o aplicativo vai parar de transmitir.',
    before_schedule_message:
      'Você está prestes a iniciar a transmissão antes do horário programado para o evento. Observe que interromper a transmissão encerrará o evento. ',
    browser_unsupportive_message: `Seu navegador não oferece suporte para compartilhamento de tela. Você pode ver os navegadores suportados neste link`,
    cancel_switch_host_message:
      'Host não disponível. O evento será continuado do seu final. ',
    coaching_prompt_message:
      'Você não pode sair desta página até o evento terminar.',
    event_modal_warn: 'Você quer sair deste evento?',
    confirm_message: 'Seu evento terminará se você clicar em OK.',
    screen_share_denied: 'Você negou compartilhar sua tela',
    media_not_found:
      'Câmera ou microfone não foram encontrados ou não são permitidos em seu dispositivo.',
    media_not_access:
      'Câmera ou microfone está sendo usado por algum outro processo que não permite ler os dispositivos',
    constraint_error:
      'Não foi encontrado nenhum dispositivo que se encaixe nas suas restrições de vídeo e áudio. Você pode alterar as restrições de vídeo e áudio ',
    media_access_denied:
      'Você não tem permissão para acessar a câmera e o microfone.'
  },

  filters: {
    days7: 'Últimos 7 dias',
    days15: 'Últimos 15 dias',
    days30: 'Últimos 30 dias',
    days365: 'Últimos 365 dias',
    date: 'Data Criada',
    relevance: 'Relevância',
    popularity: 'Popularidade',
    name: 'Nome',
    group: 'Grupo',
    Newest_to_Oldest: 'Mais novo para o mais antigo',
    Oldest_to_Newest: 'Mais antigo para o mais novo',
    A_Z: 'A a Z',
    Z_A: 'Z para A'
  },

  helpers: {
    password:
      'Para garantir a segurança da sua conta, exigimos pelo menos um número minúsculo na sua senha. Você também precisa ter um comprimento mínimo de 10 caracteres. ',
    phone: 'Inclua o código do país do seu telefone, por exemplo: +65',
    username:
      'Seu nome de usuário é tratado como informação pública e compartilhado com outros usuários conforme necessário. Como tal, recomendamos que você não use informações pessoais em seu nome de usuário ',
    public_description_normal:
      'Seu <0><0/></0> foi salvo e é considerado privado por padrão. Isso significa que apenas você pode ver este conteúdo. Para publicar este conteúdo você pode selecionar uma das opções abaixo. Publicar seu curso para o público significa que ele estará disponível para todos os usuários da plataforma. A opção Usuários específicos permitirá que você compartilhe seu curso com usuários específicos usando o endereço de e-mail associado à conta Sharelook. ',
    public_description_admin:
      'Este <0><0/></0> foi salvo e é considerado privado por padrão. Isso significa que apenas você (e o criador do conteúdo) podem ver esse conteúdo. Para publicar este conteúdo você pode selecionar uma das opções abaixo. Publicar seu curso para o público significa que ele estará disponível para todos os usuários da plataforma - incluindo aqueles fora de sua organização. Publicá-lo na organização significa que todos os usuários dentro da organização poderão vê-lo. Você também pode publicá-lo para um ou mais grupos, o que significa que apenas os usuários desses grupos poderão vê-lo. Por último, você tem a opção de publicá-lo para usuários específicos dentro e fora de sua organização usando o endereço de e-mail da conta Sharelook. '
  },

  labels: {
    add: 'Adicionar',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Tipo de resposta',
    answers: 'Respostas',
    back_to_quiz: 'Voltar para a lista de Quiz',
    back_to_question: 'Voltar à lista de perguntas',
    chat: 'Bate-papo',
    chat_available: 'O bate-papo não está disponível neste evento',
    chat_report: 'Relatório de bate-papo',
    choice_single: 'Escolha única',
    choice_multiple: 'Múltipla escolha',
    choice_free: '”Livre” escolha',
    choice_sorting: '”Escolha de” classificação',
    choice_matrix: '”Escolha” Matrix Sorting',
    clone_lesson_permission: 'Permissão de clonagem',
    code: 'Código',
    correct: 'Corrigir',
    created: 'Data Criada',
    clone_modal: 'Clone curso',
    cloning_course: 'Curso de clonagem ...',
    cloning: 'Clonando ...',
    cloning_course_desc:
      'Este processo vai demorar algum tempo. Tenha paciência por favor',
    cloning_success: 'Curso “<0 />” foi clonado com sucesso!',
    description: 'Descrição',
    disclaimer: 'Aviso Legal',
    drop_file: 'Solte o arquivo aqui ...',
    duration: 'Duração',
    edit: 'Editar',
    email: 'O email',
    event: 'Evento',
    event_all: 'Todos os seus eventos',
    event_date: 'Data/hora local do evento ao vivo',
    event_this: 'Este evento',
    expire: 'Expira em',
    expiry_date: 'Data de validade',
    forgot: 'Esqueceu a senha?',
    group: 'Grupo',
    groups_list: 'Lista de Grupos',
    host: 'Hospedeiro',
    id_annotation: 'ID de anotação',
    id_quiz: 'Quiz id',
    incorrect: 'Incorreta',
    interests: 'Interesses',
    invited: 'Convidamos',
    live_chat: 'Discussão ao vivo',
    live_stream_limit: 'Minutos de transmissão ao vivo',
    contact_text:
      'Para alterar o seu limite mensal de transmissão ao vivo, entre em contato com',
    contact_admin:
      '<0> Se você deseja alterar seu limite mensal de transmissão ao vivo, entre em contato </0><1> admin@sharelook.com </1>',
    limit_stream_text:
      'Minutos restantes de transmissão ao vivo: <0> {{ limit }} </0> minutos <1 /><2 /><3> Para alterar seu limite mensal de transmissão ao vivo, entre em contato </3><4> admin@sharelook.com </4> ',
    location: 'Localização',
    lessons: 'Lições',
    location_broadcast: 'Localização do servidor host',
    location_broadcast_subtitle:
      'Adicionar um local mais próximo do local do host da transmissão para reduzir o atraso audiovisual',
    media_manager: 'Gerente de mídia',
    minutes: 'Minutos',
    name: 'Nome',
    online_quiz: 'Online Quiz',
    organization: 'Organização',
    global_emotion: 'Experiência geral:',
    organizations_list: 'Lista de Organizações',
    password: 'Senha',
    participants: 'Participantes',
    picture: 'Imagem (16: 9)',
    phone: 'Telefone',
    photo: 'Foto',
    poll: 'Votação',
    position: 'Posição',
    processing: 'Em processamento',
    privacy_settings: 'Configurações de privacidade',
    question: 'Questão',
    quiz_create: 'Criar Novo Quiz',
    quiz_name: 'Nome do Quiz',
    quiz_update: 'Atualizar questionário',
    select_organization: 'Selecione uma organização',
    settings: 'Configurações',
    show: 'Mostrar',
    show_graph: 'Mostrar resultado do gráfico',
    signin: 'Assinar em',
    signup: 'Inscrever-se',
    sort_by: 'Ordenar por',
    start_date: 'Data de início',
    tags: 'Tag',
    terms: 'Eu concordo com estes <1> termos e condições </1>.',
    title: 'Título',
    topics: 'Tópicos',
    topic: 'Tópico',
    total_comments: 'Total de comentários',
    username: 'Nome de usuário',
    users_list: 'Lista de usuários',
    users_emails: 'Inserir e-mails de usuários específicos',
    description_specifiction_email:
      'Por favor, digite 1 endereço de e-mail por linha para compartilhar com vários usuários específicos.',
    message_specific_email:
      'Por favor, insira um e-mail do usuário específico.',
    viewers: 'Visualizadores',
    edit_course: 'Editar',
    edit_assessment: 'Editar',
    edit_event: 'Editar',
    delete_course: 'Excluir',
    delete_event: 'Excluir',
    delete_assessment: 'Excluir',
    view_course: 'Visão',
    view_event: 'Visão',
    view_assessment: 'Visão',
    date_event: 'Data do evento ao vivo',
    date_assessment: 'Data de avaliação ao vivo',
    clone_of: 'Clone',
    clone_course:
      'Crie um clone deste curso que você pode modificar independentemente do original, inclui todas as lições e páginas.',
    make: 'Fazer',
    available_to: 'disponível para qualquer usuário ShareLook',
    uploaded_by: 'Enviado por: ',
    course: 'Curso',
    assessment: 'Avaliação',
    user_not_exist: 'Usuário não existe, gostaria de enviar um convite?',
    check_user: 'Aviso prévio',
    user_not_exist_in_org:
      'O usuário não existe nesta organização, gostaria de enviar um convite?',
    title_modal_stream:
      'Alterar o limite de transmissão ao vivo da organização',
    des_warning_stream: 'Você está prestes a mudar',
    monthly_stream: 'limite de transmissão ao vivo mensal:',
    min_per_month: 'minutos / mês',
    broadcast_label: 'Eu quero fazer:',
    hosts_emails: `Insira emails de hosts específicos`,
    attendee_emails: `Insira e-mails de participantes específicos`,
    description_host_specifiction_email:
      'Por favor, insira 1 endereço de e-mail por linha.',
    presenter_label: 'Apresentador',
    presenter_label_conference: 'No. de pessoas',
    event_privacy: 'Modo de Conferência'
  },

  broadcastOptions: {
    stream_from_phone: 'Transmissão ao vivo com meu telefone',
    other_webrtc: 'Webinar do meu PC',
    multihost: 'Webinar multicast do meu PC',
    peer2peer: 'Sessão de Coaching',
    conference: 'Conferência ao vivo'
  },

  lessoncreate: {
    title: 'Adicionar detalhes da aula',
    subtitle:
      'Dê um nome à sua lição e diga ao seu público o que eles devem esperar aprender com ela.',
    input_label_title: 'Título da aula',
    input_label_topics: 'Tópicos de aula',
    input_label_description: 'Descrição da lição',
    delete_warning: 'Tem certeza que deseja excluir esta página?'
  },

  lessonoverview: {
    title: 'Adicionar lição',
    subtitle: 'Adicionar aula existente ou criar uma nova',
    new_lesson: 'criar uma nova lição',
    new_lesson_sub: 'Crie uma nova lição do zero!',
    existente_lesson: 'Selecionar aula existente',
    existing_lesson_sub:
      'Link para uma lição existente, as alterações feitas nesta lição também afetarão esta lição em outros cursos.',
    clone_lesson: 'duplicar aula existente',
    clone_lesson_sub:
      'Faça uma cópia única da lição neste curso; as alterações feitas nesta lição não afetarão a lição original.',
    clone_lesson_modal_sub:
      'Por favor, clique no botão clone abaixo da lição que você gostaria de adicionar ao seu curso.'
  },

  management: {
    groups_title: 'Gerenciar Grupos',
    delete_warning: 'Você tem certeza?',
    organization_title: 'Minhas Organizações',
    organization_subtitle: 'Adicionar organizações à sua lista',
    users_title: 'Gerenciar usuários',
    user_position: 'Gerente de Contas Sênior',
    user_not_found: 'Usuário não encontrado',
    select_org: 'Encontre e escolha uma organização para gerenciar usuários'
  },

  audio: {
    modal_title: 'Inserir Áudio',
    list_view: 'Exibição de lista',
    create_audio_modal_title: 'Criar Áudio',
    edit_audio_modal_title: 'Editar Áudio',
    public_audio_not_found: 'Áudio não encontrado.',
    private_audio_not_found: 'Você ainda não carregou nenhum áudio',
    are_you_sure_to_delete: 'Tem certeza que deseja deletar?',
    type_something: 'Digite algo',
    select_voice: 'Selecionar',
    file_name: 'Nome do arquivo',
    description: 'Descrição',
    topic: 'Tópico',
    key_words_tag: 'Tag de palavras-chave',
    mp3_audio: 'Áudio MP3',
    created: 'Criada',
    duration: 'Duração',
    close: 'perto'
  },

  image: {
    modal_title: 'Inserir Imagem',
    image: 'Imagem',
    pixel: 'Pixel',
    dimension: 'Dimensão',
    public_image_not_found: 'Imagem não encontrada.',
    private_image_not_found: 'Você ainda não carregou nenhuma imagem'
  },

  annotation: {
    modal_title: 'Anotação'
  },

  text: {
    modal_title: 'Editor de texto'
  },

  video: {
    modal_title: 'Inserir Vídeo',
    image: 'Vídeo',
    mp4_video: 'Vídeo MP4',
    public_video_not_found: 'Vídeo não encontrado.',
    private_video_not_found: 'Você ainda não enviou nenhum vídeo'
  },

  media: {
    title: 'Biblioteca de mídia',
    subtitle: 'Biblioteca de seus arquivos',
    modal_title: 'Carregar mídia',
    delete_warning: 'Confirmar exclusão',
    delete_message:
      'A mídia excluída ainda aparecerá nas páginas onde foi usada',
    dropzone_text: 'ou arrastar e soltar',
    delete_success: 'A mídia foi excluída com sucesso',
    upload_file: 'Subir arquivo',
    drag_drop: 'ou arrastar e soltar',
    import_file: 'Importar arquivo (s) do seu computador',
    no_media: 'Você ainda não carregou nenhuma mídia',
    media_type: 'Tipo de mídia',
    video: 'Vídeo',
    image: 'Image',
    audio: 'Áudio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Midia nao encontrada.',
    of: 'de',
    disclaimer: `Eu garanto que minha mídia não: 
- infringir os direitos de terceiros
- conter qualquer ilegalidade, incluindo conteúdo difamatório, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultuoso, ameaçador ou discriminatório, mesmo disfarçado com asteriscos
- conter quaisquer ataques pessoais a outras pessoas
- conter qualquer falsificação de identidade de outros participantes, figuras públicas ou celebridades
- conter qualquer informação pessoal sobre qualquer indivíduo sem o consentimento de tal indivíduo e não viola qualquer regulamento de proteção de dados em qualquer parte do mundo
- conter qualquer solicitação comercial ou qualquer forma de “spam” `
  },

  navigation: {
    account: 'Conta',
    Assessments: 'Assessments',
    dashboard: 'Painel de controle',
    groups: 'Gerenciamento de grupo',
    logout: 'Sair',
    organisations: 'Organizações',
    organizations_users: 'Organizações e usuários',
    reports: 'Relatórios',
    schedule: 'Cronograma',
    nowLive: 'Difundir',
    training: 'Treinamento',
    users: 'Comercial',
    workshop: 'Meu Workshop'
  },

  onboarding: {
    step1_title: 'Passo 1: Conte-nos um pouco sobre você',
    step1_subtitle: 'Qual o seu nome? De onde você é? Qual é o seu cargo? ',
    step2_title: 'Passo 2: Selecione alguma habilidade que você possa melhorar',
    step2_subtitle:
      'Em seguida, diga-nos o que você gostaria de entender melhor. Talvez algo que você ainda não aprendeu? Um novo campo de estudo? O que as pessoas que você ama fazem? '
  },

  pagebuilder: {
    title: 'Criar Aula',
    subtitle:
      'Hora de criar o conteúdo para o seu público aprender com você, você pode fotos, vídeos e infográficos',
    select_layout: 'Selecione um Layout de Página',
    template1: 'Em branco',
    template2: 'Título e Subtítulo',
    template3: 'Título e Texto',
    template4: 'Título, mídia e texto',
    template5: 'Título e mídia',
    template6: 'Título e Quiz'
  },

  pageconstructor: {
    title: 'Criar e clonar lição',
    subtitle:
      'É hora de criar o conteúdo para o seu público aprender com você, você pode adicionar fotos, vídeos e infográficos'
  },

  passwordreset: {
    success_coded:
      'Enviamos por e-mail um código de confirmação para o endereço fornecido, copie o código no campo abaixo para definir uma nova senha.',
    success_changed:
      'Você definiu com sucesso uma nova senha. Você pode entrar agora. '
  },

  placeholders: {
    search: 'Procurar',
    answer: 'Responder',
    chat: 'Diga algo...',
    code: 'Código',
    criterion: 'Critério',
    date_event: 'Selecione data e hora',
    date_start: 'Data de início',
    date_expire: 'Data de validade',
    description: 'Descrição',
    elements: 'Classificar elementos',
    email: 'O email',
    feedback_correct: 'Feedback correto',
    feedback_incorrect: 'Feedback incorreto',
    host: 'Hospedeiro',
    keywords: 'Procure palavras-chave)',
    lesson_description: 'Descrição da lição',
    location: 'Localização',
    minutes: 'Minutos',
    name: 'Nome',
    organiser: 'Autor',
    organization: 'Organização',
    password: 'Senha',
    phone: 'Telefone',
    photo: 'Foto',
    picture: 'Cenário',
    point: 'Ponto',
    position: 'Posição',
    question: 'Questão',
    quiz: 'Nome do Quiz',
    search_course: 'Pesquisa por curso',
    search_media: 'Pesquisar mídia',
    search_name: 'Procura por nome',
    search_title: 'Pesquisa por Título',
    search_training: 'Treinamento de Pesquisa',
    settings: 'Configurações',
    tags: 'Tag',
    title: 'Título',
    topics: 'Tópicos',
    username: 'Nome de usuário',
    keyword: 'Palavras-chave',
    max_500_caracteres: 'Máximo de 500 caracteres',
    no_description: 'Este arquivo não tem uma descrição',
    no_keyword: 'Este arquivo não contém nenhuma palavra-chave',
    no_topics: 'Este arquivo não tem um tópico definido',
    feedback: 'Mensagem',
    contact: 'Como podemos ajudar?'
  },

  publishsettings: {
    title: 'Configurações de publicação',
    assessment_subtitile:
      'Adicionar configurações ao seu evento, quem pode ver e interagir com ele',
    course_subtitle:
      'Adicione configurações ao seu curso, quem pode ver e interagir com ele',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ou auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ou auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ou auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ou auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ou auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ou auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis ',
    datas_validation_error: 'Ambas as datas devem ser preenchidas.',
    emails_validation_error: 'A lista de e-mail é inválida.',
    specific_email_validation_error: 'Apenas um email é permitido.',
    i_agree_to_these: 'Eu concordo com estes',
    terms_and_conditions: 'termos e Condições.',
    PublicDescription:
      'Usuários independentes gratuitos: (opções públicas e privadas) Seu [Curso | Evento | Avaliação] foi salvo e é considerado Privado por padrão. Isso significa que apenas você pode ver este conteúdo. Para publicar este conteúdo, você pode selecionar torná-lo público abaixo. Isso significa que o curso estará disponível para todos os usuários da plataforma. ',
    OrganisationsDescription: `Usuários da 'organização: (em vez de "" Concluir "" use "" Publicar "" e traga-os para a página de publicação da mesma forma que outros usuários, mas sem nenhuma das opções de publicação.)Seu [Curso | Evento | Avaliação] foi salvo e é Privado. Isso significa que apenas você e os administradores em sua organização podem vê-lo. Como usuário, você não pode publicar seu conteúdo dentro de sua organização, pois isso requer direitos de administrador. Por favor, contate um de seus Administradores e peça a eles para publicar seu conteúdo publicamente, para toda a organização, para grupos específicos dentro de sua organização ou para usuários específicos. `,
    OrganisationGroupsDescription:
      'Org Admins: (Para conteúdo feito dentro da organização: Privado, público, organização, grupos, usuários específicos): Este [Curso | Evento | Avaliação] foi salvo e é considerado Privado por padrão. Isso significa que apenas você (e o criador do conteúdo) podem ver esse conteúdo. Para publicar este conteúdo você pode selecionar uma das opções abaixo. Publicar seu curso para o público significa que ele estará disponível para todos os usuários da plataforma - incluindo aqueles fora de sua organização. Publicá-lo na organização significa que todos os usuários dentro da organização poderão vê-lo. Você também pode publicá-lo para um ou mais grupos, o que significa que apenas os usuários desses grupos poderão vê-lo. Por último, você tem a opção de publicá-lo para usuários específicos dentro e fora de sua organização usando o endereço de e-mail da conta Sharelook. ',
    SpecificUsersDescription:
      'Usuários independentes pagos: (usuários privados, públicos e específicos) Seu [Curso | Evento | Avaliação] foi salvo e é considerado Privado por padrão. Isso significa que apenas você pode ver este conteúdo. Para publicar este conteúdo você pode selecionar uma das opções abaixo. Publicar seu curso para o público significa que ele estará disponível para todos os usuários da plataforma. A opção Usuários específicos permitirá que você compartilhe seu curso com usuários específicos usando o endereço de e-mail associado à conta Sharelook. '
  },

  quiz: {
    quiz_empty: 'Você ainda não criou um questionário',
    question_empty: 'Você ainda não criou uma pergunta'
  },

  regions: {
    asia_pacific_australia: 'Austrália',
    asia_pacific_india: 'Índia',
    asia_pacific_japan: 'Japão',
    asia_pacific_s_korea: 'Coreia do Sul',
    asia_pacific_singapore: 'Cingapura',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Bélgica',
    eu_germany: 'Alemanha',
    eu_ireland: 'Irlanda',
    south_america_brazil: 'Brasil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Carolina do Sul',
    us_east_virginia: 'Virgínia',
    us_west_california: 'Califórnia',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Relatórios'
  },

  signup: {
    success_step1:
      'Enviamos por e-mail um código de verificação para o endereço que você forneceu, copie o código no campo abaixo para confirmar seu registro.',
    success_step2: 'Obrigado. Você foi registrado com sucesso.',
    privacy: `Eu concordo com os <1> termos e condições </1> e a <3> política de privacidade </3> de Sharelook.`
  },

  stream: {
    emotion_impressive: 'Impressionante',
    emotion_unimpressive: 'Unimpressive',
    message_not_started: 'Em breve',
    message_running: 'Ao vivo',
    message_processing:
      'No momento, estamos processando a gravação ao vivo para reprodução. Volte mais tarde para ver o vídeo e continuar adicionando avaliações e comentários '
  },

  tabs: {
    audience: 'Público',
    course: 'Visão geral do curso',
    details: 'Detalhes do evento ao vivo',
    description: 'Descrição',
    host: 'Hospedeiro',
    lesson: 'Visão geral da lição',
    lessons: 'Lições',
    overview: 'Visão geral',
    page: 'Construtor de Página',
    publish: 'Publicar',
    settings: 'Publicar Configuração',
    total_views: 'Visualizações totais',
    live_participates: 'Participantes ao vivo',
    live_chats: 'Live Chats',
    live_quiz: 'Enquetes ao Vivo',
    trainer_rating: 'Avaliação do instrutor',
    trainer_time: 'Trainer Times',
    courses_quizzes: 'Cursos de Quizzes',
    user_list: 'Lista de usuários',
    discussion: 'Discussão',
    notes: 'Minhas anotações'
  },

  topics: {
    SALES_TRAINING: 'Treinamento de vendas',
    NEGOTIATION_TRAINING: 'Treinamento de Negociação',
    CROSS_CULTURAL_AWARENESS: 'Consciência Intercultural',
    NETWORKING_SKILLS: 'Habilidades de rede',
    SOFTWARE_ARCHITECTURE: 'Arquitetura de software',
    PROJECT_MANAGEMENT: 'Gerenciamento de Projetos',
    DIGITAL_TRANSFORMATION: 'Transformação Digital',
    IT_CONSULTING: 'Consultoria de TI',
    MANAGEMENT_CONSULTING: 'Consultoria de gestão',
    HR_CONSULTING: 'Consultoria de RH',
    INTERNET_OF_THINGS: 'Internet das coisas (IoT)',
    CYBERSECURITY: 'Cíber segurança',
    PRIVACY_AND_GDRP: 'Privacidade e GDPR'
  },

  training: {
    title: 'Treinamento',
    title_assessment: 'Assessments',
    subtitle: 'Cursos e eventos ao vivo',
    enrolled_title: 'Cursos inscritos e eventos ao vivo',
    matriculado_subtitle: 'Cursos e eventos ao vivo em que você se inscreveu',
    enrolled_subtitle: 'Você não está matriculado em nenhum curso e evento.',
    past_live_event_title: 'Eventos ao vivo anteriores',
    past_live_event_subTitle: 'Eventos ao vivo finalizados',
    past_live_event: 'Atualmente não há eventos ao vivo anteriores.',
    recomended_title: 'Cursos Recomendados e Eventos ao Vivo',
    now_live_event_title: 'Ao vivo agora',
    now_live_event_subTitle: 'Eventos que estão ao vivo ou serão em breve',
    now_live_event: 'Atualmente não há evento ao vivo.',
    webinar_event_title: 'Canal Webinar',
    webinar_event_subTitle: 'Webinars finalizados',
    webinar_event: 'Atualmente não há webinar.',
    p2p_event_title: 'Sessões de Coaching',
    p2p_event_subTitle: 'Terminada a Sessão de Coaching',
    p2p_event: 'Atualmente não há sessão de coaching.',

    now_live_assessment_title: 'Ao vivo agora',
    now_live_assessment_subTitle:
      'Avaliação que está ao vivo ou será muito em breve',
    now_live_assessment_message: 'Atualmente não há avaliação ao vivo.',

    upcoming_assessment_title: 'Próximas avaliações ao vivo',
    upcoming_assessment_subtitle: 'Próximas avaliações ao vivo',
    upcoming_assessment_message:
      'Atualmente não há avaliação ao vivo programada.',

    past_live_assessment_title: 'Avaliações ao vivo anteriores',
    past_live_assessment_subTitle: 'Avaliações ao vivo finalizadas',
    past_live_assessment_message:
      'Atualmente não há avaliações ao vivo anteriores.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Organizamos cursos e eventos ao vivo com base em seu <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Treinamento de Pesquisa',
    search_assessment: 'Avaliação de Pesquisa',
    recomended_message: 'Atualmente não há cursos e eventos recomendados.'
  },

  warnings: {
    delete: 'Você tem certeza?'
  },

  workshop: {
    title: 'Meu Workshop',
    subtitle: 'Crie um curso ou hospede seu próprio evento ao vivo',
    new_course: 'Criar um novo curso',
    new_even: 'Criar um novo evento ao vivo',
    new_assessment: 'Criar uma nova avaliação ao vivo',
    course_title: 'Criação de cursos e eventos ao vivo',
    course_subtitle:
      'Edite e publique seu curso criado e planeje eventos ao vivo',
    tags_course: 'Curso',
    tags_live: 'Evento ao vivo',
    tags_assessment: 'Avaliação ao Vivo'
  },

  help_center: {
    sidebar: {
      title: 'Como podemos te ajudar?',
      back_to: 'Painel de controle'
    },
    menu: {
      help_center: 'Centro de ajuda',
      whats_new: 'O que há de novo',
      feedback: 'Comentários',
      feedback_title: 'Enviar feedback para sharelook',
      terms_and_conditions: 'Termos e Condições',
      privacy_policy: 'Política de Privacidade',
      contact_us: 'Contate-Nos'
    },
    get_started: {
      title: 'Comece com share look',
      description: {
        main:
          'INTEGRAMOS O VÍDEO AO VIVO EM UM CONSTRUTOR DE CURSOS FÁCIL DE USAR',
        tagline:
          'Com o sistema de transmissão ao vivo patenteado do ShareLook, você pode criar engajamento, automatizar o aprendizado e maximizar o compartilhamento de conhecimento.'
      }
    },
    whats_new: {
      title: 'Comece a compartilhar visual',
      description: {
        main:
          'Você sabia que criar um estilo de aprendizagem de Storytelling pode criar em um curto espaço de tempo e não tão caro? Você deve combinar o criador de cursos ShareLook e os respectivos talentos. Você pode nos perguntar "COMO ',
        tagline: ''
      }
    },
    create_workshop: 'Como criar um workshop',
    create_course: 'Como criar um curso',
    create_user: 'Como criar um usuário',
    create_group: 'Como Criar um Grupo',
    create_webinar: 'Como Criar Webinar',
    create_live_event: 'Como criar um evento ao vivo',
    create_live_assessment: 'Como criar avaliação ao vivo',
    create_live_on_mobile: 'Criar Live on Mobile',
    personalize_profile: 'Personalize um perfil',
    manage_group: 'Gerenciar grupo',
    report: 'Relatório',
    add_annotations: 'Como adicionar anotações / pop-ups',
    add_audio: 'Como adicionar áudio',
    add_header_and_footer: 'Adicionando Cabeçalho e Rodapé',
    add_image: 'Como adicionar imagem',
    add_quiz_content: 'Como adicionar conteúdo do questionário',
    add_text_content: 'Como adicionar conteúdo de texto',
    add_user: 'Como adicionar usuário',
    add_video: 'Como adicionar vídeo',
    clone_course: 'Como clonar o curso',
    find_live_broadcast: 'Como Encontrar uma Transmissão ao Vivo',
    contact_us: {
      title: 'Entre em contato',
      subject_placeholder: 'Digite um assunto *',
      content_placeholder: 'Digite uma mensagem *',
      subject_required: '* Assunto é obrigatório',
      content_required: '* A mensagem é obrigatória',
      submit: 'Enviar',
      cancel: 'Cancelar',
      sent: 'Enviado'
    },
    feedback: {
      feedback: 'Enviar feedback para sharelook',
      attach_title: 'Anexar um arquivo',
      choose: 'Escolher arquivo',
      detail: 'O arquivo será compartilhado com a equipe de suporte',
      content_placeholder: 'Digite uma mensagem *',
      content_required: '* A mensagem é obrigatória',
      submit: 'Enviar',
      cancel: 'Cancelar',
      sent: 'Enviado'
    }
  },
  discussion: {
    join_discussion: 'Junte-se à discussão'
  },
  notes: {
    title: 'Minhas anotações',
    add_note: 'Adicionar nova nota'
  }
,
    course_dates_validation_error: 'Insira a data de início e término deste curso.'
}
